(function () {
  "use strict";

  var MATRIX = {
  "generatedAt": "2026-05-02T17:35:12.232Z",
  "source": "Zepto Product Personalizer canvas-script.php for product 10014530142554",
  "targetHandle": "designe-deine-halskette",
  "activationParam": "solea_configurator",
  "activationValue": "1",
  "variantId": "50439805141338",
  "basePriceCents": 5999,
  "currency": "EUR",
  "materials": [
    {
      "value": "Edelstahl",
      "display": "Edelstahl",
      "cartValue": "Edelstahl",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-edelstahl.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "Edelstahl-gelbvergoldet",
      "display": "Edelstahl gelbvergoldet",
      "cartValue": "Edelstahl gelbvergoldet",
      "code": "",
      "priceDeltaCents": 500,
      "image": "",
      "imageAsset": "solea-necklace-configurator-edelstahl-gelbvergoldet.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "Edelstahl-rosevergoldet",
      "display": "Edelstahl rosevergoldet",
      "cartValue": "Edelstahl rosevergoldet",
      "code": "",
      "priceDeltaCents": 500,
      "image": "",
      "imageAsset": "solea-necklace-configurator-edelstahl-rosevergoldet.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "925-Sterling-Silber-rhodiniert",
      "display": "925 Sterling Silber rhodiniert",
      "cartValue": "925 Sterling Silber rhodiniert",
      "code": "",
      "priceDeltaCents": 3900,
      "image": "",
      "imageAsset": "solea-necklace-configurator-925-sterling-silber-rhodiniert.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    }
  ],
  "braceletTypes": [
    {
      "value": "Einfache-Kette",
      "display": "Einfache Kette",
      "cartValue": "Einfache Kette",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-einfache-kette.jpg",
      "thumbnail": "",
      "thumbnailAsset": "solea-necklace-configurator-einfache-kette.jpg"
    },
    {
      "value": "Double-Layer",
      "display": "Double Layer",
      "cartValue": "Double Layer",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-double-layer.jpg",
      "thumbnail": "",
      "thumbnailAsset": "solea-necklace-configurator-multi-layer.jpg"
    }
  ],
  "chainBranches": [
    {
      "fieldIndex": 3,
      "material": "Edelstahl-gelbvergoldet",
      "braceletType": "Einfache-Kette",
      "optionGroup": "Kettenstile & Breite der Kettenglieder- GG1L",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "Edelstahl-gelbvergoldet"
            ]
          },
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "Einfache-Kette"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "Ankerkette 1,5 mm (HK_01)",
          "display": "Ankerkette 1,5 mm",
          "cartValue": "Ankerkette 1,5 mm",
          "code": "HK_01",
          "priceDeltaCents": 300,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold7-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-1-5mm-new.webp"
        },
        {
          "value": "Paperclip-/Perlenkette Mix 3,5-8 mm (HK_18)",
          "display": "Paperclip-/Perlenkette Mix 3,5-8 mm",
          "cartValue": "Paperclip-/Perlenkette Mix 3,5-8 mm",
          "code": "HK_18",
          "priceDeltaCents": 1600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold5-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-paperclip-perlenkette-mix-3-5-8-mm-new.webp"
        },
        {
          "value": "Paperclipkette 3,5 mm (HK_17)",
          "display": "Paperclipkette 3,5 mm",
          "cartValue": "Paperclipkette 3,5 mm",
          "code": "HK_17",
          "priceDeltaCents": 500,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold9-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-paperclipkette-3-5-mm-new.webp"
        },
        {
          "value": "Samtband 10 mm (mit Kette) (HK_16)",
          "display": "Samtband 10 mm (mit Kette)",
          "cartValue": "Samtband 10 mm (mit Kette)",
          "code": "HK_16",
          "priceDeltaCents": 300,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold12-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-samtband-10-mm-mit-kette-new.webp"
        },
        {
          "value": "Samtband 10 mm (ohne Kette) (HK_13)",
          "display": "Samtband 10 mm (ohne Kette)",
          "cartValue": "Samtband 10 mm (ohne Kette)",
          "code": "HK_13",
          "priceDeltaCents": 300,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold10-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-samtband-10-mm-ohne-kette-new.webp"
        },
        {
          "value": "Schlangenkette 3 mm (HK_12)",
          "display": "Schlangenkette 3 mm",
          "cartValue": "Schlangenkette 3 mm",
          "code": "HK_12",
          "priceDeltaCents": 1200,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold2-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-schlangenkette-3-mm-new.webp"
        },
        {
          "value": "Singapurkette 2 mm (HK_07)",
          "display": "Singapurkette 2 mm",
          "cartValue": "Singapurkette 2 mm",
          "code": "HK_07",
          "priceDeltaCents": 600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold4-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-singapurkette-2-mm-new.webp"
        }
      ]
    },
    {
      "fieldIndex": 4,
      "material": "Edelstahl",
      "braceletType": "Einfache-Kette",
      "optionGroup": "Kettenstile & Breite der Kettenglieder-ES1L",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "Edelstahl"
            ]
          },
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "Einfache-Kette"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "Ankerkette 1,5 mm (HK_47)",
          "display": "Ankerkette 1,5 mm",
          "cartValue": "Ankerkette 1,5 mm",
          "code": "HK_47",
          "priceDeltaCents": 800,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl13-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-1-5-mm.webp"
        },
        {
          "value": "Ankerkette 2 mm (HK_46)",
          "display": "Ankerkette 2 mm",
          "cartValue": "Ankerkette 2 mm",
          "code": "HK_46",
          "priceDeltaCents": 500,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl17-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-2-mm.webp"
        },
        {
          "value": "Organzaband-gewachste Schnur Mix 1-7 mm (HK_49)",
          "display": "Organzaband-gewachste Schnur Mix 1-7 mm",
          "cartValue": "Organzaband-gewachste Schnur Mix 1-7 mm",
          "code": "HK_49",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl11-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-organzaband.webp"
        },
        {
          "value": "Paperclipkette 3,5 mm (HK_48)",
          "display": "Paperclipkette 3,5 mm",
          "cartValue": "Paperclipkette 3,5 mm",
          "code": "HK_48",
          "priceDeltaCents": 600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl12-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-paperclipkette-3-5-mm.webp"
        },
        {
          "value": "Samtband 10 mm (HK_45)",
          "display": "Samtband 10 mm",
          "cartValue": "Samtband 10 mm",
          "code": "HK_45",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl19-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-edelstahl19-photoroom.webp"
        },
        {
          "value": "Satelliten-Ankerkette 2-2,5 mm (HK_40)",
          "display": "Satelliten-Ankerkette 2-2,5 mm",
          "cartValue": "Satelliten-Ankerkette 2-2,5 mm",
          "code": "HK_40",
          "priceDeltaCents": 500,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl6-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satelliten-ankerkette-2-2-5-mm.webp"
        },
        {
          "value": "Satelliten-Ankerkette 1-3 mm (HK_41)",
          "display": "Satelliten-Ankerkette 1-3 mm",
          "cartValue": "Satelliten-Ankerkette 1-3 mm",
          "code": "HK_41",
          "priceDeltaCents": 500,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl5-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satelliten-ankerkette-1-3-mm.webp"
        },
        {
          "value": "Schlangenkette 2 mm (HK_44)",
          "display": "Schlangenkette 2 mm",
          "cartValue": "Schlangenkette 2 mm",
          "code": "HK_44",
          "priceDeltaCents": 700,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl14-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-schlangenkette-2-mm.webp"
        },
        {
          "value": "Singapurkette 3,5 mm (HK_43)",
          "display": "Singapurkette 3,5 mm",
          "cartValue": "Singapurkette 3,5 mm",
          "code": "HK_43",
          "priceDeltaCents": 500,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl15-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-singapurkette-3-5-mm.webp"
        },
        {
          "value": "Singapurkette 1,5 mm (HK_08)",
          "display": "Singapurkette 1,5 mm",
          "cartValue": "Singapurkette 1,5 mm",
          "code": "HK_08",
          "priceDeltaCents": 500,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl16-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-singapurkette-1-5-mm.webp"
        },
        {
          "value": "Venezianerkette 1 mm (HK_42)",
          "display": "Venezianerkette 1 mm",
          "cartValue": "Venezianerkette 1 mm",
          "code": "HK_42",
          "priceDeltaCents": 600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl18-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-venezianerkette-1-mm.webp"
        }
      ]
    },
    {
      "fieldIndex": 5,
      "material": "Edelstahl-rosevergoldet",
      "braceletType": "Einfache-Kette",
      "optionGroup": "Kettenstile & Breite der Kettenglieder-RG1L",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "Edelstahl-rosevergoldet"
            ]
          },
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "Einfache-Kette"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "Ankerkette 2 mm (HK_29)",
          "display": "Ankerkette 2 mm",
          "cartValue": "Ankerkette 2 mm",
          "code": "HK_29",
          "priceDeltaCents": 500,
          "image": "",
          "imageAsset": "solea-necklace-configurator-rosegold2-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satelliten-panzerkette-2-mm.webp"
        },
        {
          "value": "Ankerkette 1,2 mm (HK_28)",
          "display": "Ankerkette 1,2 mm",
          "cartValue": "Ankerkette 1,2 mm",
          "code": "HK_28",
          "priceDeltaCents": 300,
          "image": "",
          "imageAsset": "solea-necklace-configurator-rosegold8-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-12-mm.webp"
        },
        {
          "value": "Satelliten-Panzerkette 2 mm (HK_22)",
          "display": "Satelliten-Panzerkette 2 mm",
          "cartValue": "Satelliten-Panzerkette 2 mm",
          "code": "HK_22",
          "priceDeltaCents": 500,
          "image": "",
          "imageAsset": "solea-necklace-configurator-rosegold9-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-1-2-mm.webp"
        }
      ]
    },
    {
      "fieldIndex": 6,
      "material": "925-Sterling-Silber-rhodiniert",
      "braceletType": "Einfache-Kette",
      "optionGroup": "Kettenstile & Breite der Kettenglieder-SS1L",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "925-Sterling-Silber-rhodiniert"
            ]
          },
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "Einfache-Kette"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "Kordelkette 2,2 mm (HK_05)",
          "display": "Kordelkette 2,2 mm",
          "cartValue": "Kordelkette 2,2 mm",
          "code": "HK_05",
          "priceDeltaCents": 6000,
          "image": "",
          "imageAsset": "solea-necklace-configurator-silber4-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-kordelkette-2-2-mm.webp"
        },
        {
          "value": "Kordelkette 1,55 mm (HK_04)",
          "display": "Kordelkette 1,55 mm",
          "cartValue": "Kordelkette 1,55 mm",
          "code": "HK_04",
          "priceDeltaCents": 3900,
          "image": "",
          "imageAsset": "solea-necklace-configurator-silber3-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-kordelkette-1-55-mm.webp"
        },
        {
          "value": "Satelliten-Ankerkette 1 mm (HK_06)",
          "display": "Satelliten-Ankerkette 1 mm",
          "cartValue": "Satelliten-Ankerkette 1 mm",
          "code": "HK_06",
          "priceDeltaCents": 4300,
          "image": "",
          "imageAsset": "solea-necklace-configurator-silber5-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satelliten-ankerkette-1-mm.webp"
        },
        {
          "value": "Satelliten-Venezianerkette 0,9 mm (HK_10)",
          "display": "Satelliten-Venezianerkette 0,9 mm",
          "cartValue": "Satelliten-Venezianerkette 0,9 mm",
          "code": "HK_10",
          "priceDeltaCents": 3200,
          "image": "",
          "imageAsset": "solea-necklace-configurator-silber1-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satelliten-venezianerkette-0-9-mm.webp"
        },
        {
          "value": "Singapurkette 1 mm (HK_09)",
          "display": "Singapurkette 1 mm",
          "cartValue": "Singapurkette 1 mm",
          "code": "HK_09",
          "priceDeltaCents": 2700,
          "image": "",
          "imageAsset": "solea-necklace-configurator-silber2-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-singapurkette-1-mm.webp"
        }
      ]
    },
    {
      "fieldIndex": 7,
      "material": "Edelstahl-gelbvergoldet",
      "braceletType": "Double-Layer",
      "optionGroup": "Kettenstile & Breite der Kettenglieder- GG2L",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "Edelstahl-gelbvergoldet"
            ]
          },
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "Double-Layer"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "Ankerkette/Ankerkette 1,5/1,5 mm (HK_11)",
          "display": "Ankerkette/Ankerkette 1,5/1,5 mm",
          "cartValue": "Ankerkette/Ankerkette 1,5/1,5 mm",
          "code": "HK_11",
          "priceDeltaCents": 1600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold3-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-ankerkette-1-5-1-5-mm-new2.webp"
        },
        {
          "value": "Paperclipkette/Satellitenkette/Ankerkette 2,5/2/1,5 mm (HK_20)",
          "display": "Paperclipkette/Satellitenkette/Ankerkette 2,5/2/1,5 mm",
          "cartValue": "Paperclipkette/Satellitenkette/Ankerkette 2,5/2/1,5 mm",
          "code": "HK_20",
          "priceDeltaCents": 2700,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold1-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-paperclipkette-satellitenkette-ankerkette-2-5-2-1-5-mm-new2.webp"
        },
        {
          "value": "Paperclipkette/Singapurkette 3,5/2 mm (HK_21)",
          "display": "Paperclipkette/Singapurkette 3,5/2 mm",
          "cartValue": "Paperclipkette/Singapurkette 3,5/2 mm",
          "code": "HK_21",
          "priceDeltaCents": 1600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold13-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-paperclipkette-singapurkette-3-5-2-mm-new2.webp"
        },
        {
          "value": "Rundschlangenkette/Satellitenkette/Paperclipkette 1/2/3,5 mm (HK_15)",
          "display": "Rundschlangenkette/Satellitenkette/Paperclipkette 1/2/3,5 mm",
          "cartValue": "Rundschlangenkette/Satellitenkette/Paperclipkette 1/2/3,5 mm",
          "code": "HK_15",
          "priceDeltaCents": 2700,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold11-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-rundschlangenkette-satellitenkette-paperclipkette-1-2-3-5-mm-new2.webp"
        },
        {
          "value": "Satellitenkette/Ankerkette 1,5/1,5 mm (HK_14)",
          "display": "Satellitenkette/Ankerkette 1,5/1,5 mm",
          "cartValue": "Satellitenkette/Ankerkette 1,5/1,5 mm",
          "code": "HK_14",
          "priceDeltaCents": 1600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold8-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satellitenkette-ankerkette-1-5-1-5-mm-new2.webp"
        },
        {
          "value": "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm (HK_19)",
          "display": "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm",
          "cartValue": "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm",
          "code": "HK_19",
          "priceDeltaCents": 1600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-gold6-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satelliten-panzerkette-ankerkette-1-5-1-5-mm-new2.webp"
        }
      ]
    },
    {
      "fieldIndex": 8,
      "material": "Edelstahl",
      "braceletType": "Double-Layer",
      "optionGroup": "Kettenstile & Breite der Kettenglieder-ES2L",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "Edelstahl"
            ]
          },
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "Double-Layer"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "Ankerkette/Satellitenkette 1,5/1,5 mm (HK_32)",
          "display": "Ankerkette/Satellitenkette 1,5/1,5 mm",
          "cartValue": "Ankerkette/Satellitenkette 1,5/1,5 mm",
          "code": "HK_32",
          "priceDeltaCents": 1400,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl9-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-satellitenkette-1-5-1-5-mm.webp"
        },
        {
          "value": "Ankerkette/Satelliten-Panzerkette 1,3/2 mm (HK_34)",
          "display": "Ankerkette/Satelliten-Panzerkette 1,3/2 mm",
          "cartValue": "Ankerkette/Satelliten-Panzerkette 1,3/2 mm",
          "code": "HK_34",
          "priceDeltaCents": 1400,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl7-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-satelliten-panzerkette-1-3-2-mm.webp"
        },
        {
          "value": "Ankerkette/Ankerkette 1,5/1,5 mm (HK_35)",
          "display": "Ankerkette/Ankerkette 1,5/1,5 mm",
          "cartValue": "Ankerkette/Ankerkette 1,5/1,5 mm",
          "code": "HK_35",
          "priceDeltaCents": 1400,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl1-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-ankerkette-1-5-1-5-mm.webp"
        },
        {
          "value": "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm (HK_36)",
          "display": "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm",
          "cartValue": "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm",
          "code": "HK_36",
          "priceDeltaCents": 1400,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl2-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-geh-mmerte-ankerkette-venezianerkette-2-5-1-5-mm.webp"
        },
        {
          "value": "Satelliten-Panzerkette/Schlangenkette 2/2 mm (HK_38)",
          "display": "Satelliten-Panzerkette/Schlangenkette 2/2 mm",
          "cartValue": "Satelliten-Panzerkette/Schlangenkette 2/2 mm",
          "code": "HK_38",
          "priceDeltaCents": 1200,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl4-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satelliten-panzerkette-schlangenkette-2-2-mm.webp"
        },
        {
          "value": "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm (HK_39)",
          "display": "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm",
          "cartValue": "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm",
          "code": "HK_39",
          "priceDeltaCents": 1200,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl10-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satelliten-panzerkette-ankerkette-1-5-1-5-mm.webp"
        },
        {
          "value": "Schlangenkette/Singapurkette 2/1,7 mm (HK_37)",
          "display": "Schlangenkette/Singapurkette 2/1,7 mm",
          "cartValue": "Schlangenkette/Singapurkette 2/1,7 mm",
          "code": "HK_37",
          "priceDeltaCents": 1400,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl3-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-schlangenkette-singapurkette-2-1-7-mm.webp"
        },
        {
          "value": "Singapurkette/Satelliten-Panzerkette/Ankerkette 3,5/2/2 mm (HK_33)",
          "display": "Singapurkette/Satelliten-Panzerkette/Ankerkette 3,5/2/2 mm",
          "cartValue": "Singapurkette/Satelliten-Panzerkette/Ankerkette 3,5/2/2 mm",
          "code": "HK_33",
          "priceDeltaCents": 2500,
          "image": "",
          "imageAsset": "solea-necklace-configurator-edelstahl8-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-singapurkette-satelliten-panzerkette-ankerkette-3-5-2-2-mm.webp"
        }
      ]
    },
    {
      "fieldIndex": 9,
      "material": "Edelstahl-rosevergoldet",
      "braceletType": "Double-Layer",
      "optionGroup": "Kettenstile & Breite der Kettenglieder-RG2L",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "Edelstahl-rosevergoldet"
            ]
          },
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "Double-Layer"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Langstrang) (HK_23)",
          "display": "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Langstrang)",
          "cartValue": "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Langstrang)",
          "code": "HK_23",
          "priceDeltaCents": 1600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-rosegold6-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-ankerkette-1-1-mm-mit-perle-auf-langstrang.webp"
        },
        {
          "value": "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Kurzstrang) (HK_24)",
          "display": "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Kurzstrang)",
          "cartValue": "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Kurzstrang)",
          "code": "HK_24",
          "priceDeltaCents": 1600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-rosegold4-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-ankerkette-1-1-mm-mit-perle-auf-kurzstrang.webp"
        },
        {
          "value": "Ankerkette/Ankerkette 1,3/1,3 mm (HK_31)",
          "display": "Ankerkette/Ankerkette 1,3/1,3 mm",
          "cartValue": "Ankerkette/Ankerkette 1,3/1,3 mm",
          "code": "HK_31",
          "priceDeltaCents": 1600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-rosegold10-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-ankerkette-1-3-1-3-mm.webp"
        },
        {
          "value": "Ankerkette/Ankerkette 2,5/2,5 mm (HK_26)",
          "display": "Ankerkette/Ankerkette 2,5/2,5 mm",
          "cartValue": "Ankerkette/Ankerkette 2,5/2,5 mm",
          "code": "HK_26",
          "priceDeltaCents": 1400,
          "image": "",
          "imageAsset": "solea-necklace-configurator-rosegold7-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-ankerkette-2-5-2-5-mm.webp"
        },
        {
          "value": "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm (HK_30)",
          "display": "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm",
          "cartValue": "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm",
          "code": "HK_30",
          "priceDeltaCents": 1600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-rosegold12-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-geh-mmerte-ankerkette-venezianerkette-2-5-1-5mm.webp"
        },
        {
          "value": "Satelliten-Panzerkette 2/2/2 mm (HK_25)",
          "display": "Satelliten-Panzerkette 2/2/2 mm",
          "cartValue": "Satelliten-Panzerkette 2/2/2 mm",
          "code": "HK_25",
          "priceDeltaCents": 2700,
          "image": "",
          "imageAsset": "solea-necklace-configurator-rosegold5-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satelliten-panzerkette-2-2-2-mm.webp"
        },
        {
          "value": "Satelliten-Panzerkette/Ankerkette 2/2,5 mm (HK_27)",
          "display": "Satelliten-Panzerkette/Ankerkette 2/2,5 mm",
          "cartValue": "Satelliten-Panzerkette/Ankerkette 2/2,5 mm",
          "code": "HK_27",
          "priceDeltaCents": 1600,
          "image": "",
          "imageAsset": "solea-necklace-configurator-rosegold1-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-satelliten-panzerkette-ankerkette-2-2-5-mm.webp"
        }
      ]
    },
    {
      "fieldIndex": 10,
      "material": "925-Sterling-Silber-rhodiniert",
      "braceletType": "Double-Layer",
      "optionGroup": "Kettenstile & Breite der Kettenglieder-SS2L",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "925-Sterling-Silber-rhodiniert"
            ]
          },
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "Double-Layer"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "Ankerkette/Ankerkette 1/1 mm (HK_03)",
          "display": "Ankerkette/Ankerkette 1/1 mm",
          "cartValue": "Ankerkette/Ankerkette 1/1 mm",
          "code": "HK_03",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-silber6-new.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-ankerkette-ankerkette-1-1-mm.webp"
        }
      ]
    }
  ],
  "lengthRules": [
    {
      "fieldIndex": 11,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "30cm",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Samtband 10 mm (mit Kette) (HK_16)",
              "Samtband 10 mm (ohne Kette) (HK_13)"
            ]
          },
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Samtband 10 mm (HK_45)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "30cm; Choker-hauteng",
          "display": "30cm; Choker-hauteng",
          "cartValue": "30cm; Choker-hauteng",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-30cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-30cm-v4.webp"
        }
      ]
    },
    {
      "fieldIndex": 13,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "40cm",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Schlangenkette 3 mm (HK_12)"
            ]
          },
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Organzaband-gewachste Schnur Mix 1-7 mm (HK_49)"
            ]
          },
          {
            "fieldIndex": 6,
            "operator": "1",
            "values": [
              "Kordelkette 1,55 mm (HK_04)",
              "Singapurkette 1 mm (HK_09)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "40cm; Princess-kurz",
          "display": "40cm; Princess-kurz",
          "cartValue": "40cm; Princess-kurz",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-40cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-40cm-v4.webp"
        }
      ]
    },
    {
      "fieldIndex": 15,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "45cm",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Singapurkette 2 mm (HK_07)"
            ]
          },
          {
            "fieldIndex": 5,
            "operator": "1",
            "values": [
              "Ankerkette 1,2 mm (HK_28)"
            ]
          },
          {
            "fieldIndex": 6,
            "operator": "1",
            "values": [
              "Kordelkette 2,2 mm (HK_05)",
              "Satelliten-Ankerkette 1 mm (HK_06)",
              "Satelliten-Venezianerkette 0,9 mm (HK_10)"
            ]
          },
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Schlangenkette 2 mm (HK_44)",
              "Venezianerkette 1 mm (HK_42)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "45cm; Princess",
          "display": "45cm; Princess",
          "cartValue": "45cm; Princess",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-45cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-45cm-v4.webp"
        }
      ]
    },
    {
      "fieldIndex": 17,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "30cm; 35cm; 40cm",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 5,
            "operator": "1",
            "values": [
              "Satelliten-Panzerkette 2 mm (HK_22)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "30cm; Choker-hauteng",
          "display": "30cm; Choker-hauteng",
          "cartValue": "30cm; Choker-hauteng",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-30cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-30cm-v4.webp"
        },
        {
          "value": "35cm; Choker-anliegend",
          "display": "35cm; Choker-anliegend",
          "cartValue": "35cm; Choker-anliegend",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-35cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-35cm-v4.webp"
        },
        {
          "value": "40cm; Princess-kurz",
          "display": "40cm; Princess-kurz",
          "cartValue": "40cm; Princess-kurz",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-40cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-40cm-v4.webp"
        }
      ]
    },
    {
      "fieldIndex": 18,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "35cm; 40cm; 45cm",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Paperclip-/Perlenkette Mix 3,5-8 mm (HK_18)",
              "Paperclipkette 3,5 mm (HK_17)"
            ]
          },
          {
            "fieldIndex": 5,
            "operator": "1",
            "values": [
              "Ankerkette 2 mm (HK_29)"
            ]
          },
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Satelliten-Ankerkette 1-3 mm (HK_41)",
              "Satelliten-Ankerkette 2-2,5 mm (HK_40)",
              "Singapurkette 3,5 mm (HK_43)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "35cm; Choker-anliegend",
          "display": "35cm; Choker-anliegend",
          "cartValue": "35cm; Choker-anliegend",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-35cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-35cm-v4.webp"
        },
        {
          "value": "40cm; Princess-kurz",
          "display": "40cm; Princess-kurz",
          "cartValue": "40cm; Princess-kurz",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-40cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-40cm-v4.webp"
        },
        {
          "value": "45cm; Princess",
          "display": "45cm; Princess",
          "cartValue": "45cm; Princess",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-45cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-45cm-v4.webp"
        }
      ]
    },
    {
      "fieldIndex": 19,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "40cm; 45cm; 50cm",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Ankerkette 1,5 mm (HK_01)"
            ]
          },
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Ankerkette 1,5 mm (HK_47)",
              "Paperclipkette 3,5 mm (HK_48)",
              "Singapurkette 1,5 mm (HK_08)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "40cm; Princess-kurz",
          "display": "40cm; Princess-kurz",
          "cartValue": "40cm; Princess-kurz",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-40cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-40cm-v4.webp"
        },
        {
          "value": "45cm; Princess",
          "display": "45cm; Princess",
          "cartValue": "45cm; Princess",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-45cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-45cm-v4.webp"
        },
        {
          "value": "50cm; Matinee-kurz",
          "display": "50cm; Matinee-kurz",
          "cartValue": "50cm; Matinee-kurz",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-50cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-50cm-v4.webp"
        }
      ]
    },
    {
      "fieldIndex": 20,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "50cm; 55cm; 60cm",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Ankerkette 2 mm (HK_46)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "50cm; Matinee-kurz",
          "display": "50cm; Matinee-kurz",
          "cartValue": "50cm; Matinee-kurz",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-50cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-50cm-v4.webp"
        },
        {
          "value": "55cm; Matinee",
          "display": "55cm; Matinee",
          "cartValue": "55cm; Matinee",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-55cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-55cm-v4.webp"
        },
        {
          "value": "60cm; Opera-kurz",
          "display": "60cm; Opera-kurz",
          "cartValue": "60cm; Opera-kurz",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-60cm-v4.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-60cm-v4.webp"
        }
      ]
    },
    {
      "fieldIndex": 21,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "35cm/45cm: Double-Layer",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 2,5/2,5 mm (HK_26)"
            ]
          },
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1,5/1,5 mm (HK_35)",
              "Satelliten-Panzerkette/Schlangenkette 2/2 mm (HK_38)",
              "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm (HK_39)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "35cm/45cm: Double-Layer",
          "display": "35cm/45cm: Double-Layer",
          "cartValue": "35cm/45cm: Double-Layer",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-2lagig-35-45-v1.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-2lagig-35-45-v1.webp"
        }
      ]
    },
    {
      "fieldIndex": 23,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "35cm/45cm: Double-Layer",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1,3/1,3 mm (HK_31)"
            ]
          },
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Ankerkette/Satelliten-Panzerkette 1,3/2 mm (HK_34)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "35cm/45cm: Double-Layer",
          "display": "35cm/45cm: Double-Layer",
          "cartValue": "35cm/45cm: Double-Layer",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-2lagig-35-45-v1.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-2lagig-35-45-v1.webp"
        }
      ]
    },
    {
      "fieldIndex": 25,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "37/45cm; Double-Layer",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1,5/1,5 mm (HK_11)",
              "Paperclipkette/Singapurkette 3,5/2 mm (HK_21)",
              "Satellitenkette/Ankerkette 1,5/1,5 mm (HK_14)",
              "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm (HK_19)"
            ]
          },
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Langstrang) (HK_23)",
              "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm (HK_30)"
            ]
          },
          {
            "fieldIndex": 10,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1/1 mm (HK_03)"
            ]
          },
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm (HK_36)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "37/45cm; Double-Layer",
          "display": "37/45cm; Double-Layer",
          "cartValue": "37/45cm; Double-Layer",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-2lagig-37-45-v1.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-2lagig-37-45-v1.webp"
        }
      ]
    },
    {
      "fieldIndex": 27,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "40/45cm; Double-Layer",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Kurzstrang) (HK_24)",
              "Satelliten-Panzerkette/Ankerkette 2/2,5 mm (HK_27)"
            ]
          },
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Ankerkette/Satellitenkette 1,5/1,5 mm (HK_32)",
              "Schlangenkette/Singapurkette 2/1,7 mm (HK_37)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "40/45cm; Double-Layer",
          "display": "40/45cm; Double-Layer",
          "cartValue": "40/45cm; Double-Layer",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-2lagig-40-45-v1.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-2lagig-40-45-v1.webp"
        }
      ]
    },
    {
      "fieldIndex": 29,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "35/37/45cm; Triple-Layer",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Rundschlangenkette/Satellitenkette/Paperclipkette 1/2/3,5 mm (HK_15)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "35/37/45cm; Triple-Layer",
          "display": "35/37/45cm; Triple-Layer",
          "cartValue": "35/37/45cm; Triple-Layer",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-3lagig-35-37-45-v1.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-3lagig-35-37-45-v1.webp"
        }
      ]
    },
    {
      "fieldIndex": 31,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "35/40/50cm; Triple-Layer",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Satelliten-Panzerkette 2/2/2 mm (HK_25)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "35/40/50cm; Triple-Layer",
          "display": "35/40/50cm; Triple-Layer",
          "cartValue": "35/40/50cm; Triple-Layer",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-3lagig-35-40-50-v1.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-3lagig-35-40-50-v1.webp"
        }
      ]
    },
    {
      "fieldIndex": 33,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "35/45/55cm; Triple-Layer",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Singapurkette/Satelliten-Panzerkette/Ankerkette 3,5/2/2 mm (HK_33)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "35/45/55cm; Triple-Layer",
          "display": "35/45/55cm; Triple-Layer",
          "cartValue": "35/45/55cm; Triple-Layer",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-3lagig-35-45-55-v1.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-3lagig-35-45-55-v1.webp"
        }
      ]
    },
    {
      "fieldIndex": 35,
      "label": "Kettenl\u00e4nge w\u00e4hlen",
      "optionGroup": "35/45/60cm; Triple-Layer",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Paperclipkette/Satellitenkette/Ankerkette 2,5/2/1,5 mm (HK_20)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "35/45/60cm; Triple-Layer",
          "display": "35/45/60cm; Triple-Layer",
          "cartValue": "35/45/60cm; Triple-Layer",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-length-3lagig-35-45-60-v1.webp",
          "thumbnail": "",
          "thumbnailAsset": "solea-necklace-configurator-length-3lagig-35-45-60-v1.webp"
        }
      ]
    }
  ],
  "shellRules": [
    {
      "fieldIndex": 37,
      "label": "Schalengr\u00f6\u00dfe w\u00e4hlen",
      "optionGroup": "Epoxidschalen Durchmesser 10er Set",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 5,
            "operator": "1",
            "values": [
              "Ankerkette 1,2 mm (HK_28)"
            ]
          },
          {
            "fieldIndex": 6,
            "operator": "1",
            "values": [
              "Satelliten-Ankerkette 1 mm (HK_06)",
              "Satelliten-Venezianerkette 0,9 mm (HK_10)",
              "Singapurkette 1 mm (HK_09)"
            ]
          },
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Venezianerkette 1 mm (HK_42)"
            ]
          },
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1,3/1,3 mm (HK_31)",
              "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Kurzstrang) (HK_24)",
              "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Langstrang) (HK_23)"
            ]
          },
          {
            "fieldIndex": 10,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1/1 mm (HK_03)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "10 mm",
          "display": "10 mm",
          "cartValue": "10 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-10er-set-10.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "12 mm",
          "display": "12 mm",
          "cartValue": "12 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-10er-set-12.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        }
      ]
    },
    {
      "fieldIndex": 38,
      "label": "Schalengr\u00f6\u00dfe w\u00e4hlen",
      "optionGroup": "Epoxidschalen Durchmesser 12er Set",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Ankerkette 1,5 mm (HK_01)",
              "Singapurkette 2 mm (HK_07)"
            ]
          },
          {
            "fieldIndex": 5,
            "operator": "1",
            "values": [
              "Ankerkette 2 mm (HK_29)",
              "Satelliten-Panzerkette 2 mm (HK_22)"
            ]
          },
          {
            "fieldIndex": 6,
            "operator": "1",
            "values": [
              "Kordelkette 1,55 mm (HK_04)"
            ]
          },
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Ankerkette 1,5 mm (HK_47)",
              "Ankerkette 2 mm (HK_46)",
              "Schlangenkette 2 mm (HK_44)",
              "Singapurkette 1,5 mm (HK_08)"
            ]
          },
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1,5/1,5 mm (HK_11)",
              "Paperclipkette/Satellitenkette/Ankerkette 2,5/2/1,5 mm (HK_20)",
              "Satellitenkette/Ankerkette 1,5/1,5 mm (HK_14)",
              "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm (HK_19)"
            ]
          },
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm (HK_30)",
              "Satelliten-Panzerkette 2/2/2 mm (HK_25)"
            ]
          },
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1,5/1,5 mm (HK_35)",
              "Ankerkette/Satellitenkette 1,5/1,5 mm (HK_32)",
              "Ankerkette/Satelliten-Panzerkette 1,3/2 mm (HK_34)",
              "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm (HK_36)",
              "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm (HK_39)",
              "Satelliten-Panzerkette/Schlangenkette 2/2 mm (HK_38)",
              "Schlangenkette/Singapurkette 2/1,7 mm (HK_37)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "10 mm",
          "display": "10 mm",
          "cartValue": "10 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-12er-set-10.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "12 mm",
          "display": "12 mm",
          "cartValue": "12 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-12er-set-12.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "14 mm",
          "display": "14 mm",
          "cartValue": "14 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-12er-set-14.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        }
      ]
    },
    {
      "fieldIndex": 39,
      "label": "Schalengr\u00f6\u00dfe w\u00e4hlen",
      "optionGroup": "Epoxidschalen Durchmesser 14er Set",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 6,
            "operator": "1",
            "values": [
              "Kordelkette 2,2 mm (HK_05)"
            ]
          },
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Rundschlangenkette/Satellitenkette/Paperclipkette 1/2/3,5 mm (HK_15)"
            ]
          },
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 2,5/2,5 mm (HK_26)",
              "Satelliten-Panzerkette/Ankerkette 2/2,5 mm (HK_27)"
            ]
          },
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Singapurkette/Satelliten-Panzerkette/Ankerkette 3,5/2/2 mm (HK_33)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "12 mm",
          "display": "12 mm",
          "cartValue": "12 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-14er-set-12.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "14 mm",
          "display": "14 mm",
          "cartValue": "14 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-14er-set-14.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "16 mm",
          "display": "16 mm",
          "cartValue": "16 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-14er-set-16.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        }
      ]
    },
    {
      "fieldIndex": 40,
      "label": "Schalengr\u00f6\u00dfe w\u00e4hlen",
      "optionGroup": "Epoxidschalen Durchmesser 16er Set",
      "condition": {
        "type": "or",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Paperclip-/Perlenkette Mix 3,5-8 mm (HK_18)",
              "Paperclipkette 3,5 mm (HK_17)",
              "Samtband 10 mm (mit Kette) (HK_16)",
              "Samtband 10 mm (ohne Kette) (HK_13)",
              "Schlangenkette 3 mm (HK_12)"
            ]
          },
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Paperclipkette 3,5 mm (HK_48)",
              "Satelliten-Ankerkette 1-3 mm (HK_41)",
              "Satelliten-Ankerkette 2-2,5 mm (HK_40)",
              "Singapurkette 3,5 mm (HK_43)",
              "Samtband 10 mm (HK_45)",
              "Organzaband-gewachste Schnur Mix 1-7 mm (HK_49)"
            ]
          },
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Paperclipkette/Singapurkette 3,5/2 mm (HK_21)"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "14 mm",
          "display": "14 mm",
          "cartValue": "14 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-16er-set-14.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "16 mm",
          "display": "16 mm",
          "cartValue": "16 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-16er-set-16.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "18 mm",
          "display": "18 mm",
          "cartValue": "18 mm",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-necklace-configurator-16er-set-18.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        }
      ]
    }
  ],
  "epoxyRules": [
    {
      "fieldIndex": 41,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Ankerkette 1,5 mm (HK_01)"
            ]
          },
          {
            "fieldIndex": 19,
            "operator": "1",
            "values": [
              "40cm; Princess-kurz",
              "45cm; Princess",
              "50cm; Matinee-kurz"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 42,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 10,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1/1 mm (HK_03)"
            ]
          },
          {
            "fieldIndex": 25,
            "operator": "1",
            "values": [
              "37/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 37,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 43,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 6,
            "operator": "1",
            "values": [
              "Kordelkette 1,55 mm (HK_04)"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 44,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 6,
            "operator": "1",
            "values": [
              "Kordelkette 2,2 mm (HK_05)"
            ]
          },
          {
            "fieldIndex": 15,
            "operator": "1",
            "values": [
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 39,
            "operator": "1",
            "values": [
              "12 mm",
              "14 mm",
              "16 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 45,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 6,
            "operator": "1",
            "values": [
              "Satelliten-Ankerkette 1 mm (HK_06)"
            ]
          },
          {
            "fieldIndex": 15,
            "operator": "1",
            "values": [
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 37,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 46,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Singapurkette 2 mm (HK_07)"
            ]
          },
          {
            "fieldIndex": 15,
            "operator": "1",
            "values": [
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 47,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Singapurkette 1,5 mm (HK_08)"
            ]
          },
          {
            "fieldIndex": 19,
            "operator": "1",
            "values": [
              "40cm; Princess-kurz",
              "45cm; Princess",
              "50cm; Matinee-kurz"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 48,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 6,
            "operator": "1",
            "values": [
              "Singapurkette 1 mm (HK_09)"
            ]
          },
          {
            "fieldIndex": 37,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 49,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 6,
            "operator": "1",
            "values": [
              "Satelliten-Venezianerkette 0,9 mm (HK_10)"
            ]
          },
          {
            "fieldIndex": 15,
            "operator": "1",
            "values": [
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 37,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 50,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1,5/1,5 mm (HK_11)"
            ]
          },
          {
            "fieldIndex": 25,
            "operator": "1",
            "values": [
              "37/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 51,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Schlangenkette 3 mm (HK_12)"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 52,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Samtband 10 mm (ohne Kette) (HK_13)"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 53,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Satellitenkette/Ankerkette 1,5/1,5 mm (HK_14)"
            ]
          },
          {
            "fieldIndex": 25,
            "operator": "1",
            "values": [
              "37/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 54,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Rundschlangenkette/Satellitenkette/Paperclipkette 1/2/3,5 mm (HK_15)"
            ]
          },
          {
            "fieldIndex": 29,
            "operator": "1",
            "values": [
              "35/37/45cm; Triple-Layer"
            ]
          },
          {
            "fieldIndex": 39,
            "operator": "1",
            "values": [
              "12 mm",
              "14 mm",
              "16 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 55,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Samtband 10 mm (mit Kette) (HK_16)"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 56,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Paperclipkette 3,5 mm (HK_17)"
            ]
          },
          {
            "fieldIndex": 18,
            "operator": "1",
            "values": [
              "35cm; Choker-anliegend",
              "40cm; Princess-kurz",
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 57,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "Paperclip-/Perlenkette Mix 3,5-8 mm (HK_18)"
            ]
          },
          {
            "fieldIndex": 18,
            "operator": "1",
            "values": [
              "35cm; Choker-anliegend",
              "40cm; Princess-kurz",
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 58,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm (HK_19)"
            ]
          },
          {
            "fieldIndex": 25,
            "operator": "1",
            "values": [
              "37/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 59,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Paperclipkette/Satellitenkette/Ankerkette 2,5/2/1,5 mm (HK_20)"
            ]
          },
          {
            "fieldIndex": 35,
            "operator": "1",
            "values": [
              "35/45/60cm; Triple-Layer"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 60,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 7,
            "operator": "1",
            "values": [
              "Paperclipkette/Singapurkette 3,5/2 mm (HK_21)"
            ]
          },
          {
            "fieldIndex": 25,
            "operator": "1",
            "values": [
              "37/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 61,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 5,
            "operator": "1",
            "values": [
              "Satelliten-Panzerkette 2 mm (HK_22)"
            ]
          },
          {
            "fieldIndex": 17,
            "operator": "1",
            "values": [
              "30cm; Choker-hauteng",
              "35cm; Choker-anliegend",
              "40cm; Princess-kurz"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 62,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Langstrang) (HK_23)"
            ]
          },
          {
            "fieldIndex": 25,
            "operator": "1",
            "values": [
              "37/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 37,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 63,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1/1 mm (mit Perle auf Kurzstrang) (HK_24)"
            ]
          },
          {
            "fieldIndex": 27,
            "operator": "1",
            "values": [
              "40/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 37,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 64,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Satelliten-Panzerkette 2/2/2 mm (HK_25)"
            ]
          },
          {
            "fieldIndex": 31,
            "operator": "1",
            "values": [
              "35/40/50cm; Triple-Layer"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 65,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 2,5/2,5 mm (HK_26)"
            ]
          },
          {
            "fieldIndex": 39,
            "operator": "1",
            "values": [
              "12 mm",
              "14 mm",
              "16 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 66,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Satelliten-Panzerkette/Ankerkette 2/2,5 mm (HK_27)"
            ]
          },
          {
            "fieldIndex": 27,
            "operator": "1",
            "values": [
              "40/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 39,
            "operator": "1",
            "values": [
              "12 mm",
              "14 mm",
              "16 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 67,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 5,
            "operator": "1",
            "values": [
              "Ankerkette 1,2 mm (HK_28)"
            ]
          },
          {
            "fieldIndex": 15,
            "operator": "1",
            "values": [
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 37,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 68,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 5,
            "operator": "1",
            "values": [
              "Ankerkette 2 mm (HK_29)"
            ]
          },
          {
            "fieldIndex": 18,
            "operator": "1",
            "values": [
              "35cm; Choker-anliegend",
              "40cm; Princess-kurz",
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 69,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm (HK_30)"
            ]
          },
          {
            "fieldIndex": 25,
            "operator": "1",
            "values": [
              "37/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 70,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 9,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1,3/1,3 mm (HK_31)"
            ]
          },
          {
            "fieldIndex": 37,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 71,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Ankerkette/Satellitenkette 1,5/1,5 mm (HK_32)"
            ]
          },
          {
            "fieldIndex": 27,
            "operator": "1",
            "values": [
              "40/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 72,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Singapurkette/Satelliten-Panzerkette/Ankerkette 3,5/2/2 mm (HK_33)"
            ]
          },
          {
            "fieldIndex": 33,
            "operator": "1",
            "values": [
              "35/45/55cm; Triple-Layer"
            ]
          },
          {
            "fieldIndex": 39,
            "operator": "1",
            "values": [
              "12 mm",
              "14 mm",
              "16 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 73,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Ankerkette/Satelliten-Panzerkette 1,3/2 mm (HK_34)"
            ]
          },
          {
            "fieldIndex": 23,
            "operator": "1",
            "values": [
              "35cm/45cm: Double-Layer"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 74,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Ankerkette/Ankerkette 1,5/1,5 mm (HK_35)"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 75,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "geh\u00e4mmerte Ankerkette/Venezianerkette 2,5/1,5 mm (HK_36)"
            ]
          },
          {
            "fieldIndex": 25,
            "operator": "1",
            "values": [
              "37/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 76,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Schlangenkette/Singapurkette 2/1,7 mm (HK_37)"
            ]
          },
          {
            "fieldIndex": 27,
            "operator": "1",
            "values": [
              "40/45cm; Double-Layer"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 77,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Satelliten-Panzerkette/Schlangenkette 2/2 mm (HK_38)"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 78,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 8,
            "operator": "1",
            "values": [
              "Satelliten-Panzerkette/Ankerkette 1,5/1,5 mm (HK_39)"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 79,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Satelliten-Ankerkette 2-2,5 mm (HK_40)"
            ]
          },
          {
            "fieldIndex": 18,
            "operator": "1",
            "values": [
              "35cm; Choker-anliegend",
              "40cm; Princess-kurz",
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 80,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Satelliten-Ankerkette 1-3 mm (HK_41)"
            ]
          },
          {
            "fieldIndex": 18,
            "operator": "1",
            "values": [
              "35cm; Choker-anliegend",
              "40cm; Princess-kurz",
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 81,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Venezianerkette 1 mm (HK_42)"
            ]
          },
          {
            "fieldIndex": 15,
            "operator": "1",
            "values": [
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 37,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 82,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Singapurkette 3,5 mm (HK_43)"
            ]
          },
          {
            "fieldIndex": 18,
            "operator": "1",
            "values": [
              "35cm; Choker-anliegend",
              "40cm; Princess-kurz",
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 83,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Schlangenkette 2 mm (HK_44)"
            ]
          },
          {
            "fieldIndex": 15,
            "operator": "1",
            "values": [
              "45cm; Princess"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 84,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Samtband 10 mm (HK_45)"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 85,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Ankerkette 2 mm (HK_46)",
              "Samtband 10 mm (HK_45)"
            ]
          },
          {
            "fieldIndex": 20,
            "operator": "1",
            "values": [
              "50cm; Matinee-kurz",
              "55cm; Matinee",
              "60cm; Opera-kurz"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 86,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Ankerkette 1,5 mm (HK_47)",
              "Samtband 10 mm (HK_45)"
            ]
          },
          {
            "fieldIndex": 19,
            "operator": "1",
            "values": [
              "40cm; Princess-kurz",
              "45cm; Princess",
              "50cm; Matinee-kurz"
            ]
          },
          {
            "fieldIndex": 38,
            "operator": "1",
            "values": [
              "10 mm",
              "12 mm",
              "14 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 87,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Paperclipkette 3,5 mm (HK_48)",
              "Samtband 10 mm (HK_45)"
            ]
          },
          {
            "fieldIndex": 19,
            "operator": "1",
            "values": [
              "40cm; Princess-kurz",
              "45cm; Princess",
              "50cm; Matinee-kurz"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 88,
      "label": "Epoxiddesign w\u00e4hlen",
      "optionGroup": "Anh\u00e4nger Designs",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "Organzaband-gewachste Schnur Mix 1-7 mm (HK_49)"
            ]
          },
          {
            "fieldIndex": 40,
            "operator": "1",
            "values": [
              "14 mm",
              "16 mm",
              "18 mm"
            ]
          }
        ]
      }
    }
  ],
  "previewPlacements": {
    "HK_01": {
      "x": 49.36,
      "y": 54.11,
      "size": 9.67,
      "scaleX": 0.64,
      "scaleY": 0.64,
      "rotate": 0
    },
    "HK_03": {
      "x": 49.18,
      "y": 58.74,
      "size": 7.63,
      "scaleX": 0.7,
      "scaleY": 0.67,
      "rotate": 0
    },
    "HK_04": {
      "x": 48.99,
      "y": 47.28,
      "size": 7.63,
      "scaleX": 0.83,
      "scaleY": 0.83,
      "rotate": 0
    },
    "HK_05": {
      "x": 49.46,
      "y": 53.89,
      "size": 9.67,
      "scaleX": 0.65,
      "scaleY": 0.64,
      "rotate": 0
    },
    "HK_06": {
      "x": 50.12,
      "y": 52.1,
      "size": 6,
      "scaleX": 0.73,
      "scaleY": 0.71,
      "rotate": 0
    },
    "HK_07": {
      "x": 48.23,
      "y": 48.06,
      "size": 8.26,
      "scaleX": 0.75,
      "scaleY": 0.73,
      "rotate": 0
    },
    "HK_08": {
      "x": 49.27,
      "y": 52.97,
      "size": 8.1,
      "scaleX": 0.66,
      "scaleY": 0.66,
      "rotate": 0
    },
    "HK_09": {
      "x": 48.04,
      "y": 40.5,
      "size": 8.1,
      "scaleX": 0.55,
      "scaleY": 0.56,
      "rotate": 0
    },
    "HK_10": {
      "x": 49.27,
      "y": 61.26,
      "size": 8.1,
      "scaleX": 0.54,
      "scaleY": 0.54,
      "rotate": 0
    },
    "HK_11": {
      "x": 48.99,
      "y": 55.34,
      "size": 8.1,
      "scaleX": 0.76,
      "scaleY": 0.75,
      "rotate": 0
    },
    "HK_12": {
      "x": 49.08,
      "y": 46.36,
      "size": 6,
      "scaleX": 0.81,
      "scaleY": 0.81,
      "rotate": 0
    },
    "HK_13": {
      "x": 49.27,
      "y": 27.24,
      "size": 8.41,
      "scaleX": 0.92,
      "scaleY": 0.91,
      "rotate": 0
    },
    "HK_14": {
      "x": 48.32,
      "y": 55.81,
      "size": 6.84,
      "scaleX": 0.95,
      "scaleY": 0.91,
      "rotate": 0
    },
    "HK_15": {
      "x": 49.27,
      "y": 54.48,
      "size": 6.68,
      "scaleX": 0.94,
      "scaleY": 0.93,
      "rotate": 0
    },
    "HK_16": {
      "x": 49.93,
      "y": 41.25,
      "size": 7.62,
      "scaleX": 0.94,
      "scaleY": 0.92,
      "rotate": 0
    },
    "HK_17": {
      "x": 49.93,
      "y": 47.11,
      "size": 7.77,
      "scaleX": 0.94,
      "scaleY": 0.94,
      "rotate": 0
    },
    "HK_18": {
      "x": 50.31,
      "y": 51.27,
      "size": 7.77,
      "scaleX": 0.9,
      "scaleY": 0.91,
      "rotate": 0
    },
    "HK_19": {
      "x": 50.4,
      "y": 53.35,
      "size": 6.83,
      "scaleX": 0.93,
      "scaleY": 0.88,
      "rotate": 0
    },
    "HK_20": {
      "x": 50.21,
      "y": 87.37,
      "size": 6.98,
      "scaleX": 0.89,
      "scaleY": 0.79,
      "rotate": 0
    },
    "HK_21": {
      "x": 48.8,
      "y": 62.9,
      "size": 6.67,
      "scaleX": 0.96,
      "scaleY": 0.93,
      "rotate": 0
    },
    "HK_22": {
      "x": 49.93,
      "y": 35.87,
      "size": 6,
      "scaleX": 0.91,
      "scaleY": 0.93,
      "rotate": 0
    },
    "HK_23": {
      "x": 49.27,
      "y": 33.69,
      "size": 6,
      "scaleX": 0.6,
      "scaleY": 0.57,
      "rotate": 0
    },
    "HK_24": {
      "x": 49.27,
      "y": 60.91,
      "size": 6,
      "scaleX": 0.89,
      "scaleY": 0.91,
      "rotate": 0
    },
    "HK_25": {
      "x": 50.5,
      "y": 72.44,
      "size": 7.61,
      "scaleX": 0.93,
      "scaleY": 0.93,
      "rotate": 0
    },
    "HK_26": {
      "x": 50.59,
      "y": 56.56,
      "size": 7.61,
      "scaleX": 0.92,
      "scaleY": 0.92,
      "rotate": 0
    },
    "HK_27": {
      "x": 48.61,
      "y": 54.86,
      "size": 6,
      "scaleX": 0.94,
      "scaleY": 0.91,
      "rotate": 0
    },
    "HK_28": {
      "x": 48.32,
      "y": 55.43,
      "size": 6,
      "scaleX": 0.6,
      "scaleY": 0.59,
      "rotate": 0
    },
    "HK_29": {
      "x": 49.65,
      "y": 54.67,
      "size": 7.92,
      "scaleX": 0.89,
      "scaleY": 0.86,
      "rotate": 0
    },
    "HK_30": {
      "x": 50.78,
      "y": 33.5,
      "size": 7.29,
      "scaleX": 0.5,
      "scaleY": 0.5,
      "rotate": 0
    },
    "HK_31": {
      "x": 50.5,
      "y": 62.8,
      "size": 7.29,
      "scaleX": 0.73,
      "scaleY": 0.74,
      "rotate": 0
    },
    "HK_32": {
      "x": 50.4,
      "y": 61.86,
      "size": 7.44,
      "scaleX": 0.72,
      "scaleY": 0.69,
      "rotate": 0
    },
    "HK_33": {
      "x": 49.84,
      "y": 80.47,
      "size": 7.9,
      "scaleX": 0.68,
      "scaleY": 0.63,
      "rotate": 0
    },
    "HK_34": {
      "x": 48.61,
      "y": 73.29,
      "size": 7.9,
      "scaleX": 0.69,
      "scaleY": 0.66,
      "rotate": 0
    },
    "HK_35": {
      "x": 48.8,
      "y": 25.94,
      "size": 6,
      "scaleX": 0.73,
      "scaleY": 0.76,
      "rotate": 0
    },
    "HK_36": {
      "x": 48.14,
      "y": 31.05,
      "size": 6,
      "scaleX": 0.75,
      "scaleY": 0.76,
      "rotate": 0
    },
    "HK_37": {
      "x": 49.27,
      "y": 51.74,
      "size": 6,
      "scaleX": 0.88,
      "scaleY": 0.87,
      "rotate": 0
    },
    "HK_38": {
      "x": 49.08,
      "y": 48.81,
      "size": 6.02,
      "scaleX": 0.86,
      "scaleY": 0.87,
      "rotate": 0
    },
    "HK_39": {
      "x": 49.65,
      "y": 64.03,
      "size": 6.02,
      "scaleX": 0.92,
      "scaleY": 0.87,
      "rotate": 0
    },
    "HK_40": {
      "x": 49.18,
      "y": 40.97,
      "size": 7.89,
      "scaleX": 0.86,
      "scaleY": 0.87,
      "rotate": 0
    },
    "HK_41": {
      "x": 48.99,
      "y": 47.21,
      "size": 6.01,
      "scaleX": 0.87,
      "scaleY": 0.85,
      "rotate": 0
    },
    "HK_42": {
      "x": 49.46,
      "y": 57.23,
      "size": 6.01,
      "scaleX": 0.89,
      "scaleY": 0.86,
      "rotate": 0
    },
    "HK_43": {
      "x": 49.36,
      "y": 41.25,
      "size": 8.51,
      "scaleX": 0.93,
      "scaleY": 0.93,
      "rotate": 0
    },
    "HK_44": {
      "x": 48.42,
      "y": 47.21,
      "size": 7.26,
      "scaleX": 0.73,
      "scaleY": 0.74,
      "rotate": 0
    },
    "HK_45": {
      "x": 49.27,
      "y": 22.45,
      "size": 6,
      "scaleX": 0.84,
      "scaleY": 0.84,
      "rotate": 0
    },
    "HK_46": {
      "x": 49.93,
      "y": 85.77,
      "size": 7.25,
      "scaleX": 0.99,
      "scaleY": 0.86,
      "rotate": 0
    },
    "HK_47": {
      "x": 49.08,
      "y": 63.18,
      "size": 7.72,
      "scaleX": 0.91,
      "scaleY": 0.91,
      "rotate": 0
    },
    "HK_48": {
      "x": 48.99,
      "y": 57.7,
      "size": 7.72,
      "scaleX": 0.82,
      "scaleY": 0.81,
      "rotate": 0
    },
    "HK_49": {
      "x": 48.04,
      "y": 23.49,
      "size": 7.09,
      "scaleX": 0.86,
      "scaleY": 0.85,
      "rotate": 0
    }
  },
  "epoxyPatterns": [
    {
      "value": "LIGHT-v2-194",
      "display": "LIGHT v2 194",
      "cartValue": "LIGHT v2 194",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-194.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-118",
      "display": "LIGHT v2 118",
      "cartValue": "LIGHT v2 118",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-118.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-155",
      "display": "LIGHT v2 155",
      "cartValue": "LIGHT v2 155",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-155.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-132",
      "display": "LIGHT v2 132",
      "cartValue": "LIGHT v2 132",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-132.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-126",
      "display": "LIGHT v2 126",
      "cartValue": "LIGHT v2 126",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-126.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-157",
      "display": "LIGHT v2 157",
      "cartValue": "LIGHT v2 157",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-157.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-123",
      "display": "LIGHT v2 123",
      "cartValue": "LIGHT v2 123",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-123.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-144",
      "display": "LIGHT v2 144",
      "cartValue": "LIGHT v2 144",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-144.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v3-162",
      "display": "LIGHT v3 162",
      "cartValue": "LIGHT v3 162",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v3-162.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-202",
      "display": "LIGHT v2 202",
      "cartValue": "LIGHT v2 202",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-202.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-96",
      "display": "LIGHT v2 96",
      "cartValue": "LIGHT v2 96",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-96.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-166",
      "display": "LIGHT v2 166",
      "cartValue": "LIGHT v2 166",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-166.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-151",
      "display": "LIGHT v2 151",
      "cartValue": "LIGHT v2 151",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-151.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-89",
      "display": "LIGHT v2 89",
      "cartValue": "LIGHT v2 89",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-89.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COPPER-131",
      "display": "COPPER 131",
      "cartValue": "COPPER 131",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-copper-131.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COPPER-210",
      "display": "COPPER 210",
      "cartValue": "COPPER 210",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-copper-210.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-119",
      "display": "GOLD 119",
      "cartValue": "GOLD 119",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-gold-119.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-176",
      "display": "GOLD 176",
      "cartValue": "GOLD 176",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-gold-176.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-113",
      "display": "YELLOW 113",
      "cartValue": "YELLOW 113",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-113.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-116",
      "display": "YELLOW 116",
      "cartValue": "YELLOW 116",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-116.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-133",
      "display": "YELLOW 133",
      "cartValue": "YELLOW 133",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-133.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-160",
      "display": "YELLOW 160",
      "cartValue": "YELLOW 160",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-160.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-163",
      "display": "YELLOW 163",
      "cartValue": "YELLOW 163",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-163.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-165",
      "display": "YELLOW 165",
      "cartValue": "YELLOW 165",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-165.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-172",
      "display": "YELLOW 172",
      "cartValue": "YELLOW 172",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-172.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-178",
      "display": "YELLOW 178",
      "cartValue": "YELLOW 178",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-178.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-183",
      "display": "YELLOW 183",
      "cartValue": "YELLOW 183",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-183.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-184",
      "display": "YELLOW 184",
      "cartValue": "YELLOW 184",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-184.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-186",
      "display": "YELLOW 186",
      "cartValue": "YELLOW 186",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-186.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-190",
      "display": "YELLOW 190",
      "cartValue": "YELLOW 190",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-190.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-199",
      "display": "YELLOW 199",
      "cartValue": "YELLOW 199",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-199.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-205",
      "display": "YELLOW 205",
      "cartValue": "YELLOW 205",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-yellow-205.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-213",
      "display": "RED 213",
      "cartValue": "RED 213",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-red-213.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-34",
      "display": "RED 34",
      "cartValue": "RED 34",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-red-34.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-161",
      "display": "RED 161",
      "cartValue": "RED 161",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-red-161.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-52",
      "display": "RED 52",
      "cartValue": "RED 52",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-red-52.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-179",
      "display": "RED 179",
      "cartValue": "RED 179",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-red-179.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-171",
      "display": "RED 171",
      "cartValue": "RED 171",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-red-171.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-101",
      "display": "RED 101",
      "cartValue": "RED 101",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-red-101.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-10",
      "display": "GREEN 10",
      "cartValue": "GREEN 10",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-10.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-107",
      "display": "GREEN 107",
      "cartValue": "GREEN 107",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-107.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-11",
      "display": "GREEN 11",
      "cartValue": "GREEN 11",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-11.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-119",
      "display": "GREEN 119",
      "cartValue": "GREEN 119",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-119.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-128",
      "display": "GREEN 128",
      "cartValue": "GREEN 128",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-128.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-13",
      "display": "GREEN 13",
      "cartValue": "GREEN 13",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-13.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-135",
      "display": "GREEN 135",
      "cartValue": "GREEN 135",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-135.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-139",
      "display": "GREEN 139",
      "cartValue": "GREEN 139",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-139.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-148",
      "display": "GREEN 148",
      "cartValue": "GREEN 148",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-148.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-158",
      "display": "GREEN 158",
      "cartValue": "GREEN 158",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-158.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-174",
      "display": "GREEN 174",
      "cartValue": "GREEN 174",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-174.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-182",
      "display": "GREEN 182",
      "cartValue": "GREEN 182",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-182.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-195",
      "display": "GREEN 195",
      "cartValue": "GREEN 195",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-195.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-196",
      "display": "GREEN 196",
      "cartValue": "GREEN 196",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-196.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-208",
      "display": "GREEN 208",
      "cartValue": "GREEN 208",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-208.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-212",
      "display": "GREEN 212",
      "cartValue": "GREEN 212",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-212.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-214",
      "display": "GREEN 214",
      "cartValue": "GREEN 214",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-214.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-217",
      "display": "GREEN 217",
      "cartValue": "GREEN 217",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-217.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-23",
      "display": "GREEN 23",
      "cartValue": "GREEN 23",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-23.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-24",
      "display": "GREEN 24",
      "cartValue": "GREEN 24",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-24.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-27",
      "display": "GREEN 27",
      "cartValue": "GREEN 27",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-27.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-36",
      "display": "GREEN 36",
      "cartValue": "GREEN 36",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-36.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-37",
      "display": "GREEN 37",
      "cartValue": "GREEN 37",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-37.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-43",
      "display": "GREEN 43",
      "cartValue": "GREEN 43",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-43.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-5",
      "display": "GREEN 5",
      "cartValue": "GREEN 5",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-5.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-50",
      "display": "GREEN 50",
      "cartValue": "GREEN 50",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-50.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-51",
      "display": "GREEN 51",
      "cartValue": "GREEN 51",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-51.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-54",
      "display": "GREEN 54",
      "cartValue": "GREEN 54",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-54.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-55",
      "display": "GREEN 55",
      "cartValue": "GREEN 55",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-55.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-65",
      "display": "GREEN 65",
      "cartValue": "GREEN 65",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-65.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-8",
      "display": "GREEN 8",
      "cartValue": "GREEN 8",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-8.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-81",
      "display": "GREEN 81",
      "cartValue": "GREEN 81",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-81.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-94",
      "display": "GREEN 94",
      "cartValue": "GREEN 94",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-green-94.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-102",
      "display": "BLUE 102",
      "cartValue": "BLUE 102",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-102.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-103",
      "display": "BLUE 103",
      "cartValue": "BLUE 103",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-103.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-104",
      "display": "BLUE 104",
      "cartValue": "BLUE 104",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-104.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-110",
      "display": "BLUE 110",
      "cartValue": "BLUE 110",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-110.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-124",
      "display": "BLUE 124",
      "cartValue": "BLUE 124",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-124.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-145",
      "display": "BLUE 145",
      "cartValue": "BLUE 145",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-145.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-146",
      "display": "BLUE 146",
      "cartValue": "BLUE 146",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-146.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-147",
      "display": "BLUE 147",
      "cartValue": "BLUE 147",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-147.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-15",
      "display": "BLUE 15",
      "cartValue": "BLUE 15",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-15.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-150",
      "display": "BLUE 150",
      "cartValue": "BLUE 150",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-150.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-152",
      "display": "BLUE 152",
      "cartValue": "BLUE 152",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-152.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-153",
      "display": "BLUE 153",
      "cartValue": "BLUE 153",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-153.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-167",
      "display": "BLUE 167",
      "cartValue": "BLUE 167",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-167.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-193",
      "display": "BLUE 193",
      "cartValue": "BLUE 193",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-193.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-197",
      "display": "BLUE 197",
      "cartValue": "BLUE 197",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-197.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-200",
      "display": "BLUE 200",
      "cartValue": "BLUE 200",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-200.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-201",
      "display": "BLUE 201",
      "cartValue": "BLUE 201",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-201.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-21",
      "display": "BLUE 21",
      "cartValue": "BLUE 21",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-21.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-210",
      "display": "BLUE 210",
      "cartValue": "BLUE 210",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-210.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-215",
      "display": "BLUE 215",
      "cartValue": "BLUE 215",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-215.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-216",
      "display": "BLUE 216",
      "cartValue": "BLUE 216",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-216.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-22",
      "display": "BLUE 22",
      "cartValue": "BLUE 22",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-22.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-28",
      "display": "BLUE 28",
      "cartValue": "BLUE 28",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-28.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-29",
      "display": "BLUE 29",
      "cartValue": "BLUE 29",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-29.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-30",
      "display": "BLUE 30",
      "cartValue": "BLUE 30",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-30.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-31",
      "display": "BLUE 31",
      "cartValue": "BLUE 31",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-31.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-32",
      "display": "BLUE 32",
      "cartValue": "BLUE 32",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-32.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-33",
      "display": "BLUE 33",
      "cartValue": "BLUE 33",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-33.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-4",
      "display": "BLUE 4",
      "cartValue": "BLUE 4",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-4.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-57",
      "display": "BLUE 57",
      "cartValue": "BLUE 57",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-57.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-58",
      "display": "BLUE 58",
      "cartValue": "BLUE 58",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-58.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-59",
      "display": "BLUE 59",
      "cartValue": "BLUE 59",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-59.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-6",
      "display": "BLUE 6",
      "cartValue": "BLUE 6",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-6.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-60",
      "display": "BLUE 60",
      "cartValue": "BLUE 60",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-60.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-62",
      "display": "BLUE 62",
      "cartValue": "BLUE 62",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-62.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-64",
      "display": "BLUE 64",
      "cartValue": "BLUE 64",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-64.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-7",
      "display": "BLUE 7",
      "cartValue": "BLUE 7",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-7.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-71",
      "display": "BLUE 71",
      "cartValue": "BLUE 71",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-71.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-73",
      "display": "BLUE 73",
      "cartValue": "BLUE 73",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-73.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-76",
      "display": "BLUE 76",
      "cartValue": "BLUE 76",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-76.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-78",
      "display": "BLUE 78",
      "cartValue": "BLUE 78",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-78.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-79",
      "display": "BLUE 79",
      "cartValue": "BLUE 79",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-79.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-83",
      "display": "BLUE 83",
      "cartValue": "BLUE 83",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-83.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-9",
      "display": "BLUE 9",
      "cartValue": "BLUE 9",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-9.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-90",
      "display": "BLUE 90",
      "cartValue": "BLUE 90",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-90.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-92",
      "display": "BLUE 92",
      "cartValue": "BLUE 92",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-92.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-93",
      "display": "BLUE 93",
      "cartValue": "BLUE 93",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-93.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-95",
      "display": "BLUE 95",
      "cartValue": "BLUE 95",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-95.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-97",
      "display": "BLUE 97",
      "cartValue": "BLUE 97",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-97.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-99",
      "display": "BLUE 99",
      "cartValue": "BLUE 99",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-blue-99.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-100",
      "display": "VIOLET 100",
      "cartValue": "VIOLET 100",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-100.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-137",
      "display": "VIOLET 137",
      "cartValue": "VIOLET 137",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-137.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-181",
      "display": "VIOLET 181",
      "cartValue": "VIOLET 181",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-181.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-19",
      "display": "VIOLET 19",
      "cartValue": "VIOLET 19",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-19.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-2",
      "display": "VIOLET 2",
      "cartValue": "VIOLET 2",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-2.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-209",
      "display": "VIOLET 209",
      "cartValue": "VIOLET 209",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-209.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-26",
      "display": "VIOLET 26",
      "cartValue": "VIOLET 26",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-26.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-49",
      "display": "VIOLET 49",
      "cartValue": "VIOLET 49",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-49.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-61",
      "display": "VIOLET 61",
      "cartValue": "VIOLET 61",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-61.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-74",
      "display": "VIOLET 74",
      "cartValue": "VIOLET 74",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-74.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-75",
      "display": "VIOLET 75",
      "cartValue": "VIOLET 75",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-75.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-77",
      "display": "VIOLET 77",
      "cartValue": "VIOLET 77",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-77.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-86",
      "display": "VIOLET 86",
      "cartValue": "VIOLET 86",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-86.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-88",
      "display": "VIOLET 88",
      "cartValue": "VIOLET 88",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-violet-88.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-1",
      "display": "PINK 1",
      "cartValue": "PINK 1",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-pink-1.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-122",
      "display": "PINK 122",
      "cartValue": "PINK 122",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-pink-122.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-140",
      "display": "PINK 140",
      "cartValue": "PINK 140",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-pink-140.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-141",
      "display": "PINK 141",
      "cartValue": "PINK 141",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-pink-141.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-143",
      "display": "PINK 143",
      "cartValue": "PINK 143",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-pink-143.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-156",
      "display": "PINK 156",
      "cartValue": "PINK 156",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-pink-156.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-45",
      "display": "PINK 45",
      "cartValue": "PINK 45",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-pink-45.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-82",
      "display": "PINK 82",
      "cartValue": "PINK 82",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-pink-82.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-105",
      "display": "DARK 105",
      "cartValue": "DARK 105",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-105.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-111",
      "display": "DARK 111",
      "cartValue": "DARK 111",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-111.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-112",
      "display": "DARK 112",
      "cartValue": "DARK 112",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-112.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-115",
      "display": "DARK 115",
      "cartValue": "DARK 115",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-115.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-117",
      "display": "DARK 117",
      "cartValue": "DARK 117",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-117.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-159",
      "display": "DARK 159",
      "cartValue": "DARK 159",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-159.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-18",
      "display": "DARK 18",
      "cartValue": "DARK 18",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-18.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-20",
      "display": "DARK 20",
      "cartValue": "DARK 20",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-20.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-206",
      "display": "DARK 206",
      "cartValue": "DARK 206",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-206.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-41",
      "display": "DARK 41",
      "cartValue": "DARK 41",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-41.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-46",
      "display": "DARK 46",
      "cartValue": "DARK 46",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-46.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-48",
      "display": "DARK 48",
      "cartValue": "DARK 48",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-48.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-66",
      "display": "DARK 66",
      "cartValue": "DARK 66",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-66.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-67",
      "display": "DARK 67",
      "cartValue": "DARK 67",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-67.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-91",
      "display": "DARK 91",
      "cartValue": "DARK 91",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-91.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-98",
      "display": "DARK 98",
      "cartValue": "DARK 98",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-dark-98.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-129",
      "display": "LIGHT v2 129",
      "cartValue": "LIGHT v2 129",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-129.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-131",
      "display": "LIGHT v2 131",
      "cartValue": "LIGHT v2 131",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-131.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-134",
      "display": "LIGHT v2 134",
      "cartValue": "LIGHT v2 134",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-134.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-138",
      "display": "LIGHT v2 138",
      "cartValue": "LIGHT v2 138",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-138.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-168",
      "display": "LIGHT v2 168",
      "cartValue": "LIGHT v2 168",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-168.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-17",
      "display": "LIGHT v2 17",
      "cartValue": "LIGHT v2 17",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-17.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-175",
      "display": "LIGHT v2 175",
      "cartValue": "LIGHT v2 175",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-175.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-176",
      "display": "LIGHT v2 176",
      "cartValue": "LIGHT v2 176",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-176.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-180",
      "display": "LIGHT v2 180",
      "cartValue": "LIGHT v2 180",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-180.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v3-185",
      "display": "LIGHT v3 185",
      "cartValue": "LIGHT v3 185",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v3-185.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-187",
      "display": "LIGHT v2 187",
      "cartValue": "LIGHT v2 187",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-187.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-189",
      "display": "LIGHT v2 189",
      "cartValue": "LIGHT v2 189",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-189.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-192",
      "display": "LIGHT v2 192",
      "cartValue": "LIGHT v2 192",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-192.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-198",
      "display": "LIGHT v2 198",
      "cartValue": "LIGHT v2 198",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-198.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-203",
      "display": "LIGHT v2 203",
      "cartValue": "LIGHT v2 203",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-203.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-204",
      "display": "LIGHT v2 204",
      "cartValue": "LIGHT v2 204",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-204.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-25",
      "display": "LIGHT v2 25",
      "cartValue": "LIGHT v2 25",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-25.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-35",
      "display": "LIGHT v2 35",
      "cartValue": "LIGHT v2 35",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-35.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-42",
      "display": "LIGHT v2 42",
      "cartValue": "LIGHT v2 42",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-42.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-44",
      "display": "LIGHT v2 44",
      "cartValue": "LIGHT v2 44",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-44.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-47",
      "display": "LIGHT v2 47",
      "cartValue": "LIGHT v2 47",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-47.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-53",
      "display": "LIGHT v2 53",
      "cartValue": "LIGHT v2 53",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-53.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-63",
      "display": "LIGHT v2 63",
      "cartValue": "LIGHT v2 63",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-63.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-68",
      "display": "LIGHT v2 68",
      "cartValue": "LIGHT v2 68",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-68.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-69",
      "display": "LIGHT v2 69",
      "cartValue": "LIGHT v2 69",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-69.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-70",
      "display": "LIGHT v2 70",
      "cartValue": "LIGHT v2 70",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-70.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-72",
      "display": "LIGHT v2 72",
      "cartValue": "LIGHT v2 72",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-72.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-80",
      "display": "LIGHT v2 80",
      "cartValue": "LIGHT v2 80",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-80.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-84",
      "display": "LIGHT v2 84",
      "cartValue": "LIGHT v2 84",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-84.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-85",
      "display": "LIGHT v2 85",
      "cartValue": "LIGHT v2 85",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-85.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-87",
      "display": "LIGHT v2 87",
      "cartValue": "LIGHT v2 87",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-87.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-127",
      "display": "LIGHT v2 127",
      "cartValue": "LIGHT v2 127",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-light-v2-127.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-114",
      "display": "COLORSHIFT 114",
      "cartValue": "COLORSHIFT 114",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-114.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-12",
      "display": "COLORSHIFT 12",
      "cartValue": "COLORSHIFT 12",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-12.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-38",
      "display": "COLORSHIFT 38",
      "cartValue": "COLORSHIFT 38",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-38.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-207",
      "display": "COLORSHIFT 207",
      "cartValue": "COLORSHIFT 207",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-207.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-108",
      "display": "COLORSHIFT 108",
      "cartValue": "COLORSHIFT 108",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-108.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-191",
      "display": "COLORSHIFT 191",
      "cartValue": "COLORSHIFT 191",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-191.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-106",
      "display": "COLORSHIFT 106",
      "cartValue": "COLORSHIFT 106",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-106.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-39",
      "display": "COLORSHIFT 39",
      "cartValue": "COLORSHIFT 39",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-39.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-40",
      "display": "COLORSHIFT 40",
      "cartValue": "COLORSHIFT 40",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-40.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-16",
      "display": "COLORSHIFT 16",
      "cartValue": "COLORSHIFT 16",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-16.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-188",
      "display": "COLORSHIFT 188",
      "cartValue": "COLORSHIFT 188",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-188.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-149",
      "display": "COLORSHIFT 149",
      "cartValue": "COLORSHIFT 149",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-149.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-109",
      "display": "COLORSHIFT 109",
      "cartValue": "COLORSHIFT 109",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-109.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-125",
      "display": "COLORSHIFT 125",
      "cartValue": "COLORSHIFT 125",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-125.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-170",
      "display": "COLORSHIFT 170",
      "cartValue": "COLORSHIFT 170",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-170.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-154",
      "display": "COLORSHIFT 154",
      "cartValue": "COLORSHIFT 154",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-154.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-14",
      "display": "COLORSHIFT 14",
      "cartValue": "COLORSHIFT 14",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-14.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-121",
      "display": "COLORSHIFT 121",
      "cartValue": "COLORSHIFT 121",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-121.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-173",
      "display": "COLORSHIFT 173",
      "cartValue": "COLORSHIFT 173",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-173.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-169",
      "display": "COLORSHIFT 169",
      "cartValue": "COLORSHIFT 169",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-169.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-164",
      "display": "COLORSHIFT 164",
      "cartValue": "COLORSHIFT 164",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-colorshift-164.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-1",
      "display": "BLUE Cabochon 1",
      "cartValue": "BLUE-CABOCHON-1",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-1.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-2",
      "display": "BLUE Cabochon 2",
      "cartValue": "BLUE-CABOCHON-2",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-2.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-3",
      "display": "BLUE Cabochon 3",
      "cartValue": "BLUE-CABOCHON-3",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-3.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-4",
      "display": "BLUE Cabochon 4",
      "cartValue": "BLUE-CABOCHON-4",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-4.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-5",
      "display": "BLUE Cabochon 5",
      "cartValue": "BLUE-CABOCHON-5",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-5.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-6",
      "display": "BLUE Cabochon 6",
      "cartValue": "BLUE-CABOCHON-6",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-6.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-7",
      "display": "BLUE Cabochon 7",
      "cartValue": "BLUE-CABOCHON-7",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-7.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-8",
      "display": "BLUE Cabochon 8",
      "cartValue": "BLUE-CABOCHON-8",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-8.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-9",
      "display": "BLUE Cabochon 9",
      "cartValue": "BLUE-CABOCHON-9",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-9.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-10",
      "display": "BLUE Cabochon 10",
      "cartValue": "BLUE-CABOCHON-10",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-10.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-11",
      "display": "BLUE Cabochon 11",
      "cartValue": "BLUE-CABOCHON-11",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-11.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-12",
      "display": "BLUE Cabochon 12",
      "cartValue": "BLUE-CABOCHON-12",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-12.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-13",
      "display": "BLUE Cabochon 13",
      "cartValue": "BLUE-CABOCHON-13",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-13.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-14",
      "display": "BLUE Cabochon 14",
      "cartValue": "BLUE-CABOCHON-14",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-14.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-15",
      "display": "BLUE Cabochon 15",
      "cartValue": "BLUE-CABOCHON-15",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-15.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-16",
      "display": "BLUE Cabochon 16",
      "cartValue": "BLUE-CABOCHON-16",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-16.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-17",
      "display": "BLUE Cabochon 17",
      "cartValue": "BLUE-CABOCHON-17",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-17.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-18",
      "display": "BLUE Cabochon 18",
      "cartValue": "BLUE-CABOCHON-18",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-18.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-19",
      "display": "BLUE Cabochon 19",
      "cartValue": "BLUE-CABOCHON-19",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-19.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-20",
      "display": "BLUE Cabochon 20",
      "cartValue": "BLUE-CABOCHON-20",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-20.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-21",
      "display": "BLUE Cabochon 21",
      "cartValue": "BLUE-CABOCHON-21",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-21.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-22",
      "display": "BLUE Cabochon 22",
      "cartValue": "BLUE-CABOCHON-22",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-22.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-23",
      "display": "BLUE Cabochon 23",
      "cartValue": "BLUE-CABOCHON-23",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-23.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-24",
      "display": "BLUE Cabochon 24",
      "cartValue": "BLUE-CABOCHON-24",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-24.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-25",
      "display": "BLUE Cabochon 25",
      "cartValue": "BLUE-CABOCHON-25",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-25.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-26",
      "display": "BLUE Cabochon 26",
      "cartValue": "BLUE-CABOCHON-26",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-26.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-27",
      "display": "BLUE Cabochon 27",
      "cartValue": "BLUE-CABOCHON-27",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-27.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-28",
      "display": "BLUE Cabochon 28",
      "cartValue": "BLUE-CABOCHON-28",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-28.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-29",
      "display": "BLUE Cabochon 29",
      "cartValue": "BLUE-CABOCHON-29",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-29.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-30",
      "display": "BLUE Cabochon 30",
      "cartValue": "BLUE-CABOCHON-30",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-30.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-31",
      "display": "BLUE Cabochon 31",
      "cartValue": "BLUE-CABOCHON-31",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-31.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-32",
      "display": "BLUE Cabochon 32",
      "cartValue": "BLUE-CABOCHON-32",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-32.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-33",
      "display": "BLUE Cabochon 33",
      "cartValue": "BLUE-CABOCHON-33",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-33.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-35",
      "display": "BLUE Cabochon 35",
      "cartValue": "BLUE-CABOCHON-35",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-35.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-36",
      "display": "BLUE Cabochon 36",
      "cartValue": "BLUE-CABOCHON-36",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-36.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-37",
      "display": "BLUE Cabochon 37",
      "cartValue": "BLUE-CABOCHON-37",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-37.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-38",
      "display": "GREEN Cabochon 38",
      "cartValue": "GREEN-CABOCHON-38",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-38.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-39",
      "display": "GREEN Cabochon 39",
      "cartValue": "GREEN-CABOCHON-39",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-39.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-40",
      "display": "GREEN Cabochon 40",
      "cartValue": "GREEN-CABOCHON-40",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-40.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-41",
      "display": "GREEN Cabochon 41",
      "cartValue": "GREEN-CABOCHON-41",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-41.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-42",
      "display": "GREEN Cabochon 42",
      "cartValue": "GREEN-CABOCHON-42",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-42.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-43",
      "display": "GREEN Cabochon 43",
      "cartValue": "GREEN-CABOCHON-43",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-43.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-44",
      "display": "GREEN Cabochon 44",
      "cartValue": "GREEN-CABOCHON-44",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-44.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-45",
      "display": "GREEN Cabochon 45",
      "cartValue": "GREEN-CABOCHON-45",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-45.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-46",
      "display": "GREEN Cabochon 46",
      "cartValue": "GREEN-CABOCHON-46",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-46.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-47",
      "display": "GREEN Cabochon 47",
      "cartValue": "GREEN-CABOCHON-47",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-47.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-48",
      "display": "GREEN Cabochon 48",
      "cartValue": "GREEN-CABOCHON-48",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-48.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-49",
      "display": "GREEN Cabochon 49",
      "cartValue": "GREEN-CABOCHON-49",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-49.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-50",
      "display": "GREEN Cabochon 50",
      "cartValue": "GREEN-CABOCHON-50",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-50.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-51",
      "display": "LIGHT Cabochon 51",
      "cartValue": "LIGHT-CABOCHON-51",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-51.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-54",
      "display": "LIGHT Cabochon 54",
      "cartValue": "LIGHT-CABOCHON-54",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-54.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-55",
      "display": "LIGHT Cabochon 55",
      "cartValue": "LIGHT-CABOCHON-55",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-55.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-56",
      "display": "LIGHT Cabochon 56",
      "cartValue": "LIGHT-CABOCHON-56",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-56.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-57",
      "display": "LIGHT Cabochon 57",
      "cartValue": "LIGHT-CABOCHON-57",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-57.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-58",
      "display": "LIGHT Cabochon 58",
      "cartValue": "LIGHT-CABOCHON-58",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-58.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-60",
      "display": "GOLD Cabochon 60",
      "cartValue": "GOLD-CABOCHON-60",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-60.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-61",
      "display": "GOLD Cabochon 61",
      "cartValue": "GOLD-CABOCHON-61",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-61.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-65",
      "display": "GOLD Cabochon 65",
      "cartValue": "GOLD-CABOCHON-65",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-65.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-67",
      "display": "GOLD Cabochon 67",
      "cartValue": "GOLD-CABOCHON-67",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-67.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-69",
      "display": "GOLD Cabochon 69",
      "cartValue": "GOLD-CABOCHON-69",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-69.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-71",
      "display": "GOLD Cabochon 71",
      "cartValue": "GOLD-CABOCHON-71",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-71.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-72",
      "display": "GOLD Cabochon 72",
      "cartValue": "GOLD-CABOCHON-72",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-72.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-73",
      "display": "GOLD Cabochon 73",
      "cartValue": "GOLD-CABOCHON-73",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-73.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-80",
      "display": "GOLD Cabochon 80",
      "cartValue": "GOLD-CABOCHON-80",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-80.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-CABOCHON-62",
      "display": "DARK Cabochon 62",
      "cartValue": "DARK-CABOCHON-62",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-62.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-CABOCHON-64",
      "display": "DARK Cabochon 64",
      "cartValue": "DARK-CABOCHON-64",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-64.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-CABOCHON-70",
      "display": "DARK Cabochon 70",
      "cartValue": "DARK-CABOCHON-70",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-70.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-CABOCHON-86",
      "display": "DARK Cabochon 86",
      "cartValue": "DARK-CABOCHON-86",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-86.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-CABOCHON-74",
      "display": "VIOLET Cabochon 74",
      "cartValue": "VIOLET-CABOCHON-74",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-74.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-CABOCHON-76",
      "display": "COLORSHIFT Cabochon 76",
      "cartValue": "COLORSHIFT-CABOCHON-76",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-76.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-CABOCHON-78",
      "display": "COLORSHIFT Cabochon 78",
      "cartValue": "COLORSHIFT-CABOCHON-78",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-78.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-CABOCHON-79",
      "display": "COLORSHIFT Cabochon 79",
      "cartValue": "COLORSHIFT-CABOCHON-79",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-79.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-CABOCHON-82",
      "display": "COLORSHIFT Cabochon 82",
      "cartValue": "COLORSHIFT-CABOCHON-82",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-82.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-CABOCHON-84",
      "display": "PINK Cabochon 84",
      "cartValue": "PINK-CABOCHON-84",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-84.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-CABOCHON-90",
      "display": "PINK Cabochon 90",
      "cartValue": "PINK-CABOCHON-90",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-90.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-CABOCHON-88",
      "display": "PINK Cabochon 88",
      "cartValue": "PINK-CABOCHON-88",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-88.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-91",
      "display": "UNICOLOR Cabochon 91",
      "cartValue": "UNICOLOR-CABOCHON-91",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-91.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-92",
      "display": "UNICOLOR Cabochon 92",
      "cartValue": "UNICOLOR-CABOCHON-92",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-92.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-93",
      "display": "UNICOLOR Cabochon 93",
      "cartValue": "UNICOLOR-CABOCHON-93",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-93.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-94",
      "display": "UNICOLOR Cabochon 94",
      "cartValue": "UNICOLOR-CABOCHON-94",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-94.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-95",
      "display": "UNICOLOR Cabochon 95",
      "cartValue": "UNICOLOR-CABOCHON-95",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-95.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-98",
      "display": "UNICOLOR Cabochon 98",
      "cartValue": "UNICOLOR-CABOCHON-98",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-98.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-34",
      "display": "UNICOLOR Cabochon 34",
      "cartValue": "UNICOLOR-CABOCHON-34",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-34.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-66",
      "display": "UNICOLOR Cabochon 66",
      "cartValue": "UNICOLOR-CABOCHON-66",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-cabochon-66.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Black",
      "display": "UNICOLOR Black",
      "cartValue": "UNICOLOR-RINGFARBE-Black",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-black.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Green",
      "display": "UNICOLOR Green",
      "cartValue": "UNICOLOR-RINGFARBE-Green",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-green.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Lightblue",
      "display": "UNICOLOR Lightblue",
      "cartValue": "UNICOLOR-RINGFARBE-Lightblue",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-lightblue.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Lightgreen",
      "display": "UNICOLOR Lightgreen",
      "cartValue": "UNICOLOR-RINGFARBE-Lightgreen",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-lightgreen.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Orange",
      "display": "UNICOLOR Orange",
      "cartValue": "UNICOLOR-RINGFARBE-Orange",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-orange.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Pink",
      "display": "UNICOLOR Pink",
      "cartValue": "UNICOLOR-RINGFARBE-Pink",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-pink.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Red",
      "display": "UNICOLOR Red",
      "cartValue": "UNICOLOR-RINGFARBE-Red",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-red.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Violet",
      "display": "UNICOLOR Violet",
      "cartValue": "UNICOLOR-RINGFARBE-Violet",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-violet.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-White",
      "display": "UNICOLOR White",
      "cartValue": "UNICOLOR-RINGFARBE-White",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-white.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Yellow",
      "display": "UNICOLOR Yellow",
      "cartValue": "UNICOLOR-RINGFARBE-Yellow",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-yellow.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-G-Blue",
      "display": "UNICOLOR G Blue",
      "cartValue": "UNICOLOR-RINGFARBE-G-Blue",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-necklace-configurator-ringfarbe-g-blue.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    }
  ]
};
  var GENERATED_INPUT_SELECTOR = "[data-solea-configurator-generated]";
  var PRODUCT_PRICE_SELECTOR = ".product__price .money, .product-single__price .money, [data-product-price], [data-price-wrapper] .money, .price-item--regular, .price-item--sale";
  var PRODUCT_MEDIA_SELECTOR = ".product__photos, [data-product-images], .product-single__photos, .product__media";
  var SEARCHABLE_INITIAL_LIMIT = 18;
  var SEARCHABLE_PAGE_SIZE = 48;
  var ASSET_VERSION = String(MATRIX.generatedAt || "").replace(/[^0-9A-Za-z]+/g, "");
  var DEFAULT_PREVIEW_PLACEMENT = { x: 50, y: 52, size: 8, scaleX: 1, scaleY: 1, rotate: 0 };
  var CALIBRATION_STORAGE_KEY = "solea-necklace-preview-placements-v1";
  var PREVIEW_PLACEMENTS = {
    "AB_1": { x: 49.46, y: 79.72, size: 14.8, scaleX: 1.44, scaleY: 1.26, rotate: 0 },
    "AB_2": { x: 45.87, y: 78.02, size: 14.8, scaleX: 1.09, scaleY: 1, rotate: 0 },
    "AB_3": { x: 46.53, y: 81.61, size: 14.8, scaleX: 1.15, scaleY: 1.01, rotate: 0 },
    "AB_4": { x: 43.13, y: 80.66, size: 14.8, scaleX: 1.31, scaleY: 1.14, rotate: 0 },
    "AB_5": { x: 43.41, y: 81.32, size: 14.8, scaleX: 1.19, scaleY: 1.09, rotate: 0 },
    "AB_6": { x: 48.32, y: 78.96, size: 14.8, scaleX: 1.54, scaleY: 1.41, rotate: 0 },
    "AB_7": { x: 49.93, y: 81.14, size: 14.8, scaleX: 1.2, scaleY: 1.05, rotate: 0 },
    "AB_8": { x: 46.62, y: 79.43, size: 14.8, scaleX: 1.52, scaleY: 1.34, rotate: 0 },
    "AB_9": { x: 43.6, y: 80.47, size: 14.8, scaleX: 1.23, scaleY: 1.14, rotate: 0 },
    "AB_10": { x: 47.85, y: 80.47, size: 14.8, scaleX: 1.09, scaleY: 0.96, rotate: 0 },
    "AB_11": { x: 49.84, y: 80.38, size: 14.88, scaleX: 1.26, scaleY: 1.14, rotate: 0 },
    "AB_12": { x: 47.66, y: 79.06, size: 14.8, scaleX: 1.48, scaleY: 1.35, rotate: 0 },
    "AB_13": { x: 45.77, y: 80.85, size: 14.8, scaleX: 1.26, scaleY: 1.1, rotate: 0 },
    "AB_14": { x: 46.91, y: 80.1, size: 14.8, scaleX: 1.24, scaleY: 1.13, rotate: -11.2 },
    "AB_15": { x: 41.33, y: 82.36, size: 14.8, scaleX: 0.84, scaleY: 0.74, rotate: 0 },
    "AB_16": { x: 50.4, y: 79.06, size: 14.8, scaleX: 1.5, scaleY: 1.33, rotate: 0 },
    "AB_17": { x: 48.8, y: 78.58, size: 14.8, scaleX: 1.47, scaleY: 1.27, rotate: -14.2 },
    "AB_18": { x: 45.3, y: 80.19, size: 14.8, scaleX: 1.34, scaleY: 1.2, rotate: 0 },
    "AB_19": { x: 52.86, y: 76.79, size: 14.8, scaleX: 1.54, scaleY: 1.34, rotate: 0 },
    "AB_20": { x: 43.13, y: 78.3, size: 14.8, scaleX: 1.34, scaleY: 1.17, rotate: 0 },
    "AB_21": { x: 46.81, y: 81.99, size: 14.8, scaleX: 1.04, scaleY: 0.9, rotate: 0 },
    "AB_22": { x: 46.25, y: 78.81, size: 14.8, scaleX: 1.32, scaleY: 1.17, rotate: 0 },
    "AB_23": { x: 45.21, y: 80.28, size: 14.8, scaleX: 1.29, scaleY: 1.13, rotate: 7.7 },
    "AB_24": { x: 43.32, y: 79.81, size: 14.8, scaleX: 1.14, scaleY: 0.98, rotate: 0 },
    "AB_25": { x: 46.34, y: 80.0, size: 14.8, scaleX: 1.4, scaleY: 1.18, rotate: 0 },
    "AB_26": { x: 42.75, y: 80.38, size: 14.8, scaleX: 1.31, scaleY: 1.14, rotate: 0 },
    "AB_27": { x: 45.68, y: 78.68, size: 18.56, scaleX: 1.23, scaleY: 1.08, rotate: 0 },
    "AB_28": { x: 48.89, y: 77.64, size: 14.8, scaleX: 1.24, scaleY: 1.07, rotate: 0 },
    "AB_29": { x: 47.1, y: 79.15, size: 14.8, scaleX: 1.13, scaleY: 1.03, rotate: 0 },
    "AB_30": { x: 46.25, y: 77.83, size: 14.8, scaleX: 1.07, scaleY: 0.96, rotate: 0 },
    "AB_31": { x: 46.15, y: 77.92, size: 14.8, scaleX: 1.12, scaleY: 0.98, rotate: 0 },
    "AB_32": { x: 46.53, y: 76.88, size: 14.8, scaleX: 1.11, scaleY: 1.01, rotate: 0 },
    "AB_33": { x: 46.81, y: 81.7, size: 14.8, scaleX: 1.12, scaleY: 1.02, rotate: 0 },
    "AB_34": { x: 45.96, y: 78.58, size: 14.8, scaleX: 1.03, scaleY: 0.94, rotate: 0 },
    "AB_35": { x: 44.36, y: 80.76, size: 14.8, scaleX: 1.13, scaleY: 1.02, rotate: 4.5 },
    "AB_36": { x: 46.81, y: 80.28, size: 14.8, scaleX: 1.31, scaleY: 1.16, rotate: 0 },
    "AB_37": { x: 50.88, y: 80.66, size: 16.8, scaleX: 1.15, scaleY: 1, rotate: 0 },
    "AB_38": { x: 48.51, y: 80.85, size: 16.52, scaleX: 1.13, scaleY: 1, rotate: 0 },
    "AB_39": { x: 46.15, y: 78.02, size: 14.8, scaleX: 1.6, scaleY: 1.47, rotate: 0 },
    "AB_40": { x: 44.73, y: 77.17, size: 14.8, scaleX: 1.31, scaleY: 1.25, rotate: -35.2 },
    "AB_41": { x: 45.68, y: 80.28, size: 16.8, scaleX: 1.13, scaleY: 1.02, rotate: 0 },
    "AB_42": { x: 47.76, y: 80.38, size: 14.8, scaleX: 1.34, scaleY: 1.19, rotate: 0 },
    "AB_43": { x: 47.95, y: 81.04, size: 14.8, scaleX: 1.21, scaleY: 1.12, rotate: 0 },
    "AB_44": { x: 44.64, y: 80.28, size: 14.8, scaleX: 1.33, scaleY: 1.16, rotate: 0 },
    "AB_45": { x: 45.77, y: 81.14, size: 14.8, scaleX: 1.21, scaleY: 1.08, rotate: 0 },
    "AB_46": { x: 43.22, y: 80.47, size: 14.8, scaleX: 1.33, scaleY: 1.11, rotate: 0 },
    "AB_47": { x: 49.55, y: 80.57, size: 14.8, scaleX: 1.27, scaleY: 1.15, rotate: -3.2 },
    "AB_48": { x: 47.95, y: 80.47, size: 14.8, scaleX: 1.35, scaleY: 1.19, rotate: -5.4 },
    "AB_49": { x: 42.28, y: 80.66, size: 14.8, scaleX: 1.24, scaleY: 1.12, rotate: 10.6 }
  };
  PREVIEW_PLACEMENTS = Object.assign({}, PREVIEW_PLACEMENTS, MATRIX.previewPlacements || {});

  function isActive() {
    return true;
  }

  function isCalibrationMode() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get("solea_preview_helper") === "1" || params.get("solea_calibrator") === "1";
    } catch (error) {
      return false;
    }
  }

  function clampNumber(value, min, max, fallback) {
    var number = Number.parseFloat(value);
    if (!Number.isFinite(number)) return fallback;
    return Math.max(min, Math.min(max, number));
  }

  function normalizePlacementValue(value) {
    if (!value || typeof value !== "object") return null;
    return {
      x: clampNumber(value.x, 0, 100, DEFAULT_PREVIEW_PLACEMENT.x),
      y: clampNumber(value.y, 0, 100, DEFAULT_PREVIEW_PLACEMENT.y),
      size: clampNumber(value.size, 6, 28, DEFAULT_PREVIEW_PLACEMENT.size),
      scaleX: clampNumber(value.scaleX, 0.5, 1.6, DEFAULT_PREVIEW_PLACEMENT.scaleX),
      scaleY: clampNumber(value.scaleY, 0.5, 1.6, DEFAULT_PREVIEW_PLACEMENT.scaleY),
      rotate: clampNumber(value.rotate, -180, 180, DEFAULT_PREVIEW_PLACEMENT.rotate),
    };
  }

  function readCalibrationMap() {
    if (!isCalibrationMode()) return Object.create(null);
    try {
      var raw = window.localStorage && window.localStorage.getItem(CALIBRATION_STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      var map = Object.create(null);
      Object.keys(parsed || {}).forEach(function (code) {
        var placement = normalizePlacementValue(parsed[code]);
        if (placement) map[code] = placement;
      });
      return map;
    } catch (error) {
      return Object.create(null);
    }
  }

  function writeCalibrationMap(map) {
    if (!isCalibrationMode()) return;
    try {
      window.localStorage.setItem(CALIBRATION_STORAGE_KEY, JSON.stringify(map || {}));
    } catch (error) {
      /* localStorage can be disabled in private contexts. */
    }
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "readonly");
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        document.body.append(textarea);
        textarea.select();
        document.execCommand("copy");
        textarea.remove();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat("de-AT", {
      style: "currency",
      currency: MATRIX.currency,
    }).format(cents / 100);
  }

  function assetBaseUrl(root) {
    return String(root.dataset.assetBaseUrl || "").replace(/[^/]*$/, "");
  }

  function resolveAssetUrl(root, assetName) {
    if (!assetName) return "";
    var base = assetBaseUrl(root);
    if (!base) return "";
    return base + assetName + (ASSET_VERSION ? "?v=" + ASSET_VERSION : "");
  }

  function resizedThemeAssetUrl(url, width) {
    if (!url || !width || !/\/cdn\/shop\/t\/\d+\/assets\//.test(url) || /[?&]width=/.test(url)) return url;
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + Math.round(width);
  }

  function optionImageUrl(root, option, key) {
    if (!option) return "";
    if (key === "thumbnail" && option.thumbnailAsset) return resizedThemeAssetUrl(resolveAssetUrl(root, option.thumbnailAsset), 240);
    if (key === "thumbnail" && option.thumbnail) return option.thumbnail;
    if (option.imageAsset) {
      var imageAssetUrl = resolveAssetUrl(root, option.imageAsset);
      return key === "thumbnail" ? resizedThemeAssetUrl(imageAssetUrl, 240) : imageAssetUrl;
    }
    return option.image || "";
  }

  function fieldValue(fieldIndex, state) {
    if (fieldIndex === 1) return state.material || "";
    if (fieldIndex === 2) return state.braceletType || "";
    if (fieldIndex >= 3 && fieldIndex <= 10) return state.chainStyle || "";
    if (fieldIndex >= 11 && fieldIndex <= 36) return state.length || "";
    if (fieldIndex >= 37 && fieldIndex <= 40) return state.shellSize || "";
    return "";
  }

  function matchesCondition(condition, state) {
    if (!condition) return true;
    var checks = condition.clauses.map(function (clause) {
      var value = fieldValue(clause.fieldIndex, state);
      return clause.values.indexOf(value) !== -1;
    });
    return condition.type === "or" ? checks.some(Boolean) : checks.every(Boolean);
  }

  function activeBranch(state) {
    return MATRIX.chainBranches.find(function (branch) {
      return matchesCondition(branch.condition, state);
    }) || null;
  }

  function firstMatchingRule(rules, state) {
    return rules.find(function (rule) {
      return matchesCondition(rule.condition, state);
    }) || null;
  }

  function selectedOption(options, value) {
    return options.find(function (option) {
      return option.value === value;
    }) || null;
  }

  function currentFields(state) {
    var fields = [
      {
        id: "material",
        property: "Material w\u00e4hlen",
        label: "Material w\u00e4hlen",
        options: MATRIX.materials,
        required: true,
      },
    ];

    if (state.material) {
      fields.push({
        id: "braceletType",
        property: "Kettentyp w\u00e4hlen",
        label: "Kettentyp w\u00e4hlen",
        options: MATRIX.braceletTypes,
        required: true,
      });
    }

    var branch = activeBranch(state);
    if (branch) {
      fields.push({
        id: "chainStyle",
        property: "Kettenstil w\u00e4hlen",
        label: "Kettenstil w\u00e4hlen",
        options: branch.options,
        required: true,
      });
    }

    var lengthRule = state.chainStyle ? firstMatchingRule(MATRIX.lengthRules, state) : null;
    if (lengthRule) {
      fields.push({
        id: "length",
        property: "Kettenl\u00e4nge w\u00e4hlen",
        label: "Kettenl\u00e4nge w\u00e4hlen",
        options: lengthRule.options,
        required: true,
        autoSelectSingle: true,
      });
    }

    var shellRule = state.chainStyle ? firstMatchingRule(MATRIX.shellRules, state) : null;
    if (shellRule) {
      fields.push({
        id: "shellSize",
        property: "Schalengr\u00f6\u00dfe w\u00e4hlen",
        label: "Schalengr\u00f6\u00dfe w\u00e4hlen",
        options: shellRule.options,
        required: true,
        autoSelectSingle: true,
      });
    }

    var epoxyRule = state.chainStyle && state.shellSize ? firstMatchingRule(MATRIX.epoxyRules, state) : null;
    if (epoxyRule) {
      fields.push({
        id: "epoxyPattern",
        property: "Epoxiddesign w\u00e4hlen",
        label: "Epoxiddesign w\u00e4hlen",
        options: MATRIX.epoxyPatterns,
        required: true,
        searchable: true,
      });
    }

    return fields;
  }

  function normalizeState(state) {
    var changed = true;
    var guard = 0;

    while (changed && guard < 12) {
      changed = false;
      guard += 1;

      var fields = currentFields(state);
      var visibleIds = fields.map(function (field) { return field.id; });
      Object.keys(state).forEach(function (key) {
        if (visibleIds.indexOf(key) === -1) {
          delete state[key];
          changed = true;
        }
      });

      fields.forEach(function (field) {
        var current = state[field.id];
        var stillValid = current && field.options.some(function (option) {
          return option.value === current;
        });
        if (current && !stillValid) {
          delete state[field.id];
          changed = true;
        }
        if (!state[field.id] && field.autoSelectSingle && field.options.length === 1) {
          state[field.id] = field.options[0].value;
          changed = true;
        }
      });
    }
  }



  function diyScopeTexts() {
    var lang = (document.documentElement.lang || "").slice(0, 2).toLowerCase();
    if (lang === "en") {
      return {
        noticeLead: "This DIY configurator is only for finished SOLEA epoxy designs without sending in personal materials.",
        noticeDetail: "If you would like us to include hair, ashes, flowers, sand or fabric, please use the memorial jewelry configurator.",
        linkText: "Go to memorial jewelry",
        confirm: "I understand that no personal keepsakes can be sent in or embedded for this DIY product.",
        error: "Please confirm first that this DIY product is made without sending in personal keepsakes."
      };
    }
    if (lang === "fr") {
      return {
        noticeLead: "Ce configurateur DIY est uniquement destin\u00e9 aux designs \u00e9poxy SOLEA pr\u00eats \u00e0 choisir, sans envoi d'objets personnels.",
        noticeDetail: "Si vous souhaitez int\u00e9grer des cheveux, des cendres, des fleurs, du sable ou du tissu, veuillez utiliser le configurateur de bijoux comm\u00e9moratifs.",
        linkText: "Voir les bijoux comm\u00e9moratifs",
        confirm: "Je comprends qu'aucun souvenir personnel ne peut \u00eatre envoy\u00e9 ou int\u00e9gr\u00e9 pour ce produit DIY.",
        error: "Veuillez confirmer que ce produit DIY est r\u00e9alis\u00e9 sans envoi de souvenirs personnels."
      };
    }
    return {
      noticeLead: "Dieser DIY-Konfigurator ist nur f\u00fcr fertige SOLEA Epoxiddesigns ohne Einsendung.",
      noticeDetail: "Wenn du Haare, Asche, Bl\u00fcten, Sand oder Stoff einarbeiten lassen m\u00f6chtest, nutze bitte den Erinnerungsschmuck-Konfigurator.",
      linkText: "Zum Erinnerungsschmuck",
      confirm: "Ich verstehe, dass bei diesem DIY-Produkt keine pers\u00f6nlichen Erinnerungsst\u00fccke eingesendet oder eingearbeitet werden.",
      error: "Bitte best\u00e4tige zuerst, dass dieses DIY-Produkt ohne Einsendung pers\u00f6nlicher Erinnerungsst\u00fccke gefertigt wird."
    };
  }

  function ensureDiyScopeStyles() {
    if (document.getElementById("solea-diy-scope-styles")) return;
    var style = document.createElement("style");
    style.id = "solea-diy-scope-styles";
    style.textContent = [
      ".solea-configurator__diy-notice{margin:14px 0 12px;padding:12px 14px;border:1px solid rgba(15,74,73,.22);background:#fbf8f2;color:#241f1b;font-size:14px;line-height:1.45;border-radius:6px;}",
      ".solea-configurator__diy-notice p{margin:0;}",
      ".solea-configurator__diy-notice p+p{margin-top:6px;}",
      ".solea-configurator__diy-link{font-weight:700;color:#0f4a49;text-decoration:underline;text-underline-offset:3px;}",
      ".solea-configurator__diy-confirm{display:flex;gap:10px;align-items:flex-start;margin:12px 0 10px;font-size:14px;line-height:1.45;color:#241f1b;}",
      ".solea-configurator__diy-confirm input{margin-top:3px;min-width:18px;width:18px;height:18px;accent-color:#0f4a49;}",
      ".solea-configurator__diy-confirm span{display:block;}"
    ].join("");
    document.head.appendChild(style);
  }

  function ensureDiyScopeNotice(root) {
    if (root.querySelector("[data-diy-scope-notice]")) return;
    var status = root.querySelector("[data-status]");
    if (!status || !status.parentElement) return;
    var texts = diyScopeTexts();
    var notice = document.createElement("div");
    notice.className = "solea-configurator__diy-notice";
    notice.dataset.diyScopeNotice = "true";
    var lead = document.createElement("p");
    lead.textContent = texts.noticeLead;
    var detail = document.createElement("p");
    detail.appendChild(document.createTextNode(texts.noticeDetail + " "));
    var link = document.createElement("a");
    link.href = "/collections/erinnerungsschmuck";
    link.className = "solea-configurator__diy-link";
    link.textContent = texts.linkText;
    detail.appendChild(link);
    notice.appendChild(lead);
    notice.appendChild(detail);
    status.parentElement.insertBefore(notice, status);
  }

  function ensureDiyScopeConfirmation(root) {
    if (root.querySelector("[data-diy-scope-confirmation]")) return;
    var status = root.querySelector("[data-status]");
    if (!status || !status.parentElement) return;
    var texts = diyScopeTexts();
    var label = document.createElement("label");
    label.className = "solea-configurator__diy-confirm";
    label.dataset.diyScopeConfirmation = "true";
    var input = document.createElement("input");
    input.type = "checkbox";
    input.dataset.diyScopeConfirmInput = "true";
    var span = document.createElement("span");
    span.textContent = texts.confirm;
    label.appendChild(input);
    label.appendChild(span);
    status.parentElement.insertBefore(label, status);
  }

  function diyScopeConfirmed(root) {
    var input = root.querySelector("[data-diy-scope-confirm-input]");
    return Boolean(input && input.checked);
  }

  function localizedPropertyText(value) {
    var text = String(value || "");
    var i18n = MATRIX.soleaI18n || {};
    var exact = i18n.exact || {};
    var templates = i18n.templates || {};
    if (exact[text]) return exact[text];
    var extension = text.match(/^(.+?cm); inkl\. (.+?mm) Verl\u00e4ngerungskettchen$/);
    if (extension && templates.braceletLengthExtension) {
      return templates.braceletLengthExtension.replace("{length}", extension[1]).replace("{extension}", extension[2]);
    }
    var layers = text.match(/^(.+?)(:|;)\s*(Double-Layer|Triple-Layer)$/);
    if (layers && exact[layers[3]]) return layers[1] + layers[2] + " " + exact[layers[3]];
    return text;
  }

  function selectedProperties(state) {
    return currentFields(state).reduce(function (properties, field) {
      var option = selectedOption(field.options, state[field.id]);
      var propertyLabel = localizedPropertyText(field.property);
      if (option && field.id === "epoxyPattern") {
        properties[propertyLabel] = localizedPropertyText("Ausgew\u00e4hlt");
        properties["_SOLEA Epoxiddesign"] = option.cartValue || option.value;
      } else if (option) {
        properties[propertyLabel] = localizedPropertyText(option.cartValue || option.value);
      }
      return properties;
    }, {});
  }

  function priceParts(state) {
    var fields = currentFields(state);
    var selected = fields
      .map(function (field) {
        var option = selectedOption(field.options, state[field.id]);
        return option ? { field: field, option: option } : null;
      })
      .filter(Boolean);
    var extras = selected.reduce(function (sum, item) {
      return sum + (item.option.priceDeltaCents || 0);
    }, 0);

    return {
      base: MATRIX.basePriceCents,
      extras: extras,
      total: MATRIX.basePriceCents + extras,
      selected: selected,
    };
  }



  function soleaConfigOptionText(option) {
    if (!option) return "";
    return option.cartValue || option.display || option.value || "";
  }

  function soleaConfigSelectedField(field, state) {
    var value = state[field.id] || "";
    if (field.type === "textarea") {
      return {
        label: field.label || field.property || field.id,
        value: value,
        display: String(value || "").trim(),
        cartValue: String(value || "").trim(),
        code: "",
        imageAsset: "",
        thumbnailAsset: "",
        priceDeltaCents: 0
      };
    }

    var option = selectedOption(field.options, value);
    return {
      label: field.label || field.property || field.id,
      value: value,
      display: soleaConfigOptionText(option),
      cartValue: option ? (option.cartValue || option.value || "") : "",
      code: option && option.code ? option.code : "",
      imageAsset: option && option.imageAsset ? option.imageAsset : "",
      thumbnailAsset: option && option.thumbnailAsset ? option.thumbnailAsset : "",
      priceDeltaCents: option && option.priceDeltaCents ? option.priceDeltaCents : 0
    };
  }

  function soleaConfigShellOption(state) {
    if (!MATRIX.shellRules || !MATRIX.shellRules.length || typeof firstMatchingRule !== "function") return null;
    var shellRule = firstMatchingRule(MATRIX.shellRules, state);
    return selectedOption((shellRule || { options: [] }).options, state.shellSize);
  }

  function soleaConfigChainOption(state) {
    if (!state.chainStyle || typeof activeBranch !== "function") return null;
    return selectedOption((activeBranch(state) || { options: [] }).options, state.chainStyle);
  }

  function soleaConfigPlacementSnapshot(code, epoxyOption) {
    if (!code) return null;
    var base = Object.assign({}, DEFAULT_PREVIEW_PLACEMENT || {}, (PREVIEW_PLACEMENTS && PREVIEW_PLACEMENTS[code]) || {});
    var previewScale = epoxyOption && Number.isFinite(Number(epoxyOption.previewScale)) ? Number(epoxyOption.previewScale) : 1;
    return {
      x: Number(base.x || 0),
      y: Number(base.y || 0),
      size: Number((Number(base.size || 0) * previewScale).toFixed(4)),
      scaleX: Number(base.scaleX || 1),
      scaleY: Number(base.scaleY || 1),
      rotate: Number(base.rotate || 0)
    };
  }

  function buildSoleaConfigSnapshot(state) {
    var prices = priceParts(state);
    var selections = {};
    currentFields(state).forEach(function (field) {
      selections[field.id] = soleaConfigSelectedField(field, state);
    });

    var chain = soleaConfigChainOption(state);
    var shell = soleaConfigShellOption(state);
    var epoxy = selectedOption(MATRIX.epoxyPatterns || [], state.epoxyPattern);
    var placementCode = (chain && chain.code) || (shell && (shell.code || shell.value || shell.display)) || "";

    return {
      version: 1,
      handle: MATRIX.targetHandle || "",
      source: MATRIX.source || "",
      generatedAt: new Date().toISOString(),
      currency: MATRIX.currency || "EUR",
      basePriceCents: prices.base || 0,
      extrasCents: prices.extras || 0,
      totalCents: prices.total || 0,
      selections: selections,
      preview: {
        chainCode: chain && chain.code ? chain.code : "",
        placementCode: placementCode,
        chainImageAsset: chain && chain.imageAsset ? chain.imageAsset : "",
        shellSize: shell ? (shell.cartValue || shell.value || shell.display || "") : "",
        shellImageAsset: shell && shell.imageAsset ? shell.imageAsset : "",
        epoxyDesign: epoxy ? (epoxy.cartValue || epoxy.display || epoxy.value || "") : "",
        epoxyImageAsset: epoxy && epoxy.imageAsset ? epoxy.imageAsset : "",
        epoxyThumbnailAsset: epoxy && epoxy.thumbnailAsset ? epoxy.thumbnailAsset : "",
        placement: soleaConfigPlacementSnapshot(placementCode, epoxy)
      }
    };
  }

  function configuredProperties(state) {
    var properties = selectedProperties(state);
    var prices = priceParts(state);
    properties["_SOLEA Konfiguratorpreis EUR"] = (prices.total / 100).toFixed(2);
    properties["_SOLEA Aufpreis EUR"] = (prices.extras / 100).toFixed(2);

    var chain = selectedOption((activeBranch(state) || { options: [] }).options, state.chainStyle);
    if (chain && chain.code) {
      properties["_SOLEA Kettencode"] = chain.code;
    }

    var soleaConfigSnapshot = buildSoleaConfigSnapshot(state);
    properties["_SOLEA Config Version"] = String(soleaConfigSnapshot.version || 1);
    properties["_SOLEA Config JSON"] = JSON.stringify(soleaConfigSnapshot);

    return properties;
  }

  function formQuantity(cartForm) {
    var quantityInput = cartForm.querySelector("[name='quantity']");
    var quantity = quantityInput ? Number.parseInt(quantityInput.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function randomPricingRef() {
    return String(Math.floor((Math.random() * 1000000000) + 1));
  }

  var soleaSurchargeVariantMapCache = null;

  function soleaSurchargeVariantMap() {
    if (soleaSurchargeVariantMapCache) return soleaSurchargeVariantMapCache;
    var node = document.querySelector("script[data-solea-surcharge-variant-map]");
    var map = null;
    try {
      map = node ? JSON.parse(node.textContent || "{}") : null;
    } catch (error) {
      map = null;
    }
    if (!map || typeof map !== "object" || Array.isArray(map)) {
      throw new Error("Die gewählte Designoption ist derzeit nicht verfügbar. Bitte lade die Seite neu und versuche es erneut.");
    }
    soleaSurchargeVariantMapCache = map;
    return map;
  }

  function exactSurchargeLine(state) {
    var prices = priceParts(state);
    var cartBasePrice = MATRIX.shopifyBasePriceCents || MATRIX.basePriceCents || 0;
    var surchargeCents = Math.max(0, prices.total - cartBasePrice);
    if (surchargeCents === 0) return null;
    var variantId = Number(soleaSurchargeVariantMap()[String(surchargeCents)]);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) {
      throw new Error("Die gewählte Designoption ist derzeit nicht verfügbar. Bitte lade die Seite neu und versuche es erneut.");
    }
    return {
      variantId: variantId,
      surchargeCents: surchargeCents,
    };
  }

  function buildCartItems(state, cartForm) {
    var quantity = formQuantity(cartForm);
    var properties = configuredProperties(state);
    var surchargeLine = exactSurchargeLine(state);
    var items = [];

    if (surchargeLine) {
      if (quantity !== 1) {
        throw new Error("Konfigurierte Schmuckstücke können nur einzeln in den Warenkorb gelegt werden.");
      }
      var pricingRef = randomPricingRef();
      properties._pc_pricing_ref = pricingRef;
      items.push({
        id: surchargeLine.variantId,
        quantity: 1,
        properties: {
          _pc_pricing_ref: pricingRef,
        },
      });
    }

    items.push({
      id: Number(MATRIX.variantId),
      quantity: quantity,
      properties: properties,
    });

    return items;
  }

  function disableSubmit(cartForm, disabled) {
    cartForm.querySelectorAll("button[type='submit'], [name='add'], input[type='submit']").forEach(function (button) {
      button.disabled = disabled;
      if (disabled) {
        button.dataset.soleaSubmitting = "true";
      } else {
        delete button.dataset.soleaSubmitting;
      }
    });
  }

  function parseCartError(response, payload) {
    if (payload && typeof payload === "object") {
      return payload.description || payload.message || "Shopify hat die Warenkorb-Aktion abgelehnt.";
    }
    return response.status + " " + response.statusText;
  }

  function addConfiguredItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify({ items: items }),
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (payload) {
        if (!response.ok) {
          throw new Error(parseCartError(response, payload));
        }
        return payload;
      });
    });
  }

  function missingFields(state) {
    return currentFields(state)
      .filter(function (field) {
        return field.required && !state[field.id];
      })
      .map(function (field) {
        return field.label;
      });
  }

  function createGeneratedInput(name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    input.dataset.soleaConfiguratorGenerated = "true";
    return input;
  }

  function findCartForm(root) {
    var section = root.closest("[data-section-type='product'], .product-section") || document;
    var byId = root.dataset.productFormId ? document.getElementById(root.dataset.productFormId) : null;
    return byId || section.querySelector("form[action*='/cart/add'], form.product-single__form") || document.querySelector("form[action*='/cart/add'], form.product-single__form");
  }

  function updateCartInputs(cartForm, state) {
    cartForm.querySelectorAll(GENERATED_INPUT_SELECTOR).forEach(function (input) {
      input.remove();
    });

    Object.entries(configuredProperties(state)).forEach(function (entry) {
      cartForm.append(createGeneratedInput("properties[" + entry[0] + "]", entry[1]));
    });

    var variantInput = cartForm.querySelector("[name='id']");
    if (variantInput && MATRIX.variantId) {
      variantInput.value = MATRIX.variantId;
    }
  }

  function updateProductPrice(total) {
    document.querySelectorAll(PRODUCT_PRICE_SELECTOR).forEach(function (element) {
      if (!element.dataset.soleaOriginalPrice) {
        element.dataset.soleaOriginalPrice = element.textContent;
      }
      element.textContent = formatMoney(total);
    });
  }

  function restoreProductPrice() {
    document.querySelectorAll(PRODUCT_PRICE_SELECTOR).forEach(function (element) {
      if (element.dataset.soleaOriginalPrice) {
        element.textContent = element.dataset.soleaOriginalPrice;
      }
    });
  }

  // SOLEA_CONFIGURATOR_I18N_RUNTIME
  function readSoleaI18n(root) {
    var container = root && root.parentElement ? root.parentElement : document;
    var script = container.querySelector("script[data-solea-configurator-i18n]") || document.querySelector("script[data-solea-configurator-i18n]");
    if (!script) return { exact: {}, templates: {} };
    try {
      return JSON.parse(script.textContent || "{}");
    } catch (error) {
      return { exact: {}, templates: {} };
    }
  }

  function soleaApplyTemplate(template, values) {
    return String(template || "").replace(/\{([a-zA-Z0-9_]+)\}/g, function (_, key) {
      return values && Object.prototype.hasOwnProperty.call(values, key) ? values[key] : "";
    });
  }

  function soleaTranslateList(value, i18n) {
    return String(value || "")
      .split(/,\s*/)
      .map(function (part) { return soleaTranslateTextValue(part, i18n); })
      .join(", ");
  }

  function soleaTranslateTextValue(value, i18n) {
    var text = String(value || "");
    var trimmed = text.trim();
    if (!trimmed || !i18n) return text;
    var exact = i18n.exact || {};
    var templates = i18n.templates || {};
    var translated = exact[trimmed];
    if (!translated) {
      var counted = trimmed.match(/^(.+?) \((\d+)\)$/);
      if (counted && exact[counted[1]]) translated = exact[counted[1]] + " (" + counted[2] + ")";
    }
    if (!translated) {
      var variant = trimmed.match(/^Variante\s+(\d+)$/i);
      if (variant && templates.variant) translated = soleaApplyTemplate(templates.variant, { number: variant[1] });
    }
    if (!translated) {
      var price = trimmed.match(/^inkl\.\s+(.+?)\s+Optionsaufschlag$/);
      if (price && templates.priceWithOptions) translated = soleaApplyTemplate(templates.priceWithOptions, { amount: price[1] });
    }
    if (!translated) {
      var more = trimmed.match(/^Zeige\s+(\d+)\s+von\s+(\d+)\s+Designs\. Du kannst weitere Designs laden\.$/);
      if (more && templates.showingDesignsMore) translated = soleaApplyTemplate(templates.showingDesignsMore, { shown: more[1], total: more[2] });
    }
    if (!translated) {
      var showing = trimmed.match(/^Zeige\s+(\d+)\s+von\s+(\d+)\s+Designs\.$/);
      if (showing && templates.showingDesigns) translated = soleaApplyTemplate(templates.showingDesigns, { shown: showing[1], total: showing[2] });
    }
    if (!translated) {
      var missing = trimmed.match(/^Noch\s+(\d+)\s+Schritt(?:e)?\s+offen:\s+(.+)\.$/);
      if (missing) {
        translated = soleaApplyTemplate(missing[1] === "1" ? templates.missingOne : templates.missingMany, {
          count: missing[1],
          fields: soleaTranslateList(missing[2], i18n)
        });
      }
    }
    if (!translated) {
      var choose = trimmed.match(/^Bitte zuerst auswählen:\s+(.+)\.$/);
      if (choose && templates.chooseFirst) translated = soleaApplyTemplate(templates.chooseFirst, { fields: soleaTranslateList(choose[1], i18n) });
    }
    if (!translated || translated === trimmed) return text;
    return text.replace(trimmed, translated);
  }

  function applySoleaI18n(root, i18n) {
    if (!root || !i18n || root.__soleaI18nApplying) return;
    root.__soleaI18nApplying = true;
    try {
      var attrs = ["placeholder", "aria-label", "title"];
      root.querySelectorAll("[placeholder],[aria-label],[title]").forEach(function (element) {
        attrs.forEach(function (attr) {
          if (!element.hasAttribute(attr)) return;
          var current = element.getAttribute(attr);
          var next = soleaTranslateTextValue(current, i18n);
          if (next !== current) element.setAttribute(attr, next);
        });
      });
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          var parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          if (/^(SCRIPT|STYLE|TEXTAREA|INPUT|OPTION)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
          if (!String(node.nodeValue || "").trim()) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var current = node.nodeValue;
        var next = soleaTranslateTextValue(current, i18n);
        if (next !== current) node.nodeValue = next;
      });
    } finally {
      root.__soleaI18nApplying = false;
    }
  }

  function setupSoleaI18n(root, i18n) {
    if (!root || root.__soleaI18nObserver) return;
    var schedule = function () {
      window.clearTimeout(root.__soleaI18nTimer);
      root.__soleaI18nTimer = window.setTimeout(function () { applySoleaI18n(root, i18n); }, 0);
    };
    root.__soleaI18nObserver = new MutationObserver(schedule);
    root.__soleaI18nObserver.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["placeholder", "aria-label", "title"] });
  }

  function initRoot(root) {
    var soleaI18n = readSoleaI18n(root);
    MATRIX.soleaI18n = soleaI18n;
    setupSoleaI18n(root, soleaI18n);
    if (root.dataset.productHandle !== MATRIX.targetHandle) return;

    var cartForm = findCartForm(root);
    if (!cartForm) return;

    var state = Object.create(null);
    var searchQueries = Object.create(null);
    var optionLimits = Object.create(null);
    var epoxyPatternGroup = "";
    var epoxyGroupScrollLeft = 0;
    var activeFieldId = "";
    var calibrationMode = isCalibrationMode();
    var calibrationMap = readCalibrationMap();
    var calibrationDrafts = Object.create(null);
    var fieldsRoot = root.querySelector("[data-fields]");
    var progressBar = root.querySelector("[data-progress-bar]");
    var status = root.querySelector("[data-status]");
    var resetButton = root.querySelector("[data-reset]");
    var priceTotal = root.querySelector("[data-price-total]");
    var priceNote = root.querySelector("[data-price-note]");
    var preview = ensureProductPreview(root);
    var previewZoomMode = "detail";
    var previewZoom = createPreviewZoom();
    var previewZoomPreviousFocus = null;
    var previewSyncFrame = 0;

    ensureDiyScopeStyles();
    ensureDiyScopeNotice(root);
    ensureDiyScopeConfirmation(root);
    root.hidden = false;
    document.documentElement.classList.add("solea-configurator-active");
    if (document.body) document.body.classList.add("solea-configurator-active");
    if (calibrationMode) {
      root.classList.add("solea-configurator--calibration");
      document.documentElement.classList.add("solea-configurator-calibration-active");
    }

    function productPreviewHost() {
      var host = document.querySelector(".product__photos") || document.querySelector("[data-product-images]");
      if (host) host.classList.add("solea-configurator-preview-host");
      return host;
    }

    function syncPreviewHost() {
      if (!preview) return;
      var productHost = productPreviewHost();
      var mobile = isMobileLayout();
      var target = mobile ? root : productHost || root;
      preview.classList.toggle("solea-configurator-preview-media--mobile-sticky", mobile && target === root);
      if (preview.parentElement !== target) {
        target.insertBefore(preview, target.firstChild);
      }
    }

    function schedulePreviewHostSync() {
      if (previewSyncFrame) return;
      previewSyncFrame = window.requestAnimationFrame(function () {
        previewSyncFrame = 0;
        syncPreviewHost();
      });
    }

    function setStatus(message, stateName) {
      status.textContent = message;
      if (stateName) {
        status.dataset.state = stateName;
      } else {
        delete status.dataset.state;
      }
    }

    function calibrationControl(key, label, min, max, step) {
      var wrapper = document.createElement("label");
      wrapper.className = "solea-configurator-calibrator__control";

      var text = document.createElement("span");
      text.textContent = label;

      var input = document.createElement("input");
      input.type = "number";
      input.min = String(min);
      input.max = String(max);
      input.step = String(step);
      input.dataset.calibrationInput = key;
      input.addEventListener("input", function () {
        updateCalibrationDraft(key, input.value);
      });

      wrapper.append(text, input);
      return wrapper;
    }

    function createCalibrationPanel() {
      var panel = document.createElement("div");
      panel.className = "solea-configurator-calibrator";
      panel.dataset.previewCalibrator = "true";
      panel.hidden = true;

      var header = document.createElement("div");
      header.className = "solea-configurator-calibrator__header";

      var title = document.createElement("strong");
      title.dataset.calibrationTitle = "true";
      title.textContent = "Overlay-Kalibrierung";

      var hint = document.createElement("span");
      hint.textContent = "Im Bild ziehen, Gr\u00f6\u00dfe, Ellipse und Drehung feinjustieren.";

      header.append(title, hint);

      var controls = document.createElement("div");
      controls.className = "solea-configurator-calibrator__controls";
      controls.append(
        calibrationControl("x", "X", 0, 100, 0.05),
        calibrationControl("y", "Y", 0, 100, 0.05),
        calibrationControl("size", "Gr\u00f6\u00dfe", 6, 28, 0.05),
        calibrationControl("scaleX", "Ellipse B", 0.5, 1.6, 0.01),
        calibrationControl("scaleY", "Ellipse H", 0.5, 1.6, 0.01),
        calibrationControl("rotate", "Drehung", -45, 45, 0.1)
      );

      var actions = document.createElement("div");
      actions.className = "solea-configurator-calibrator__actions";

      var save = document.createElement("button");
      save.type = "button";
      save.dataset.calibrationSave = "true";
      save.textContent = "OK speichern";
      save.addEventListener("click", saveCalibrationPlacement);

      var reset = document.createElement("button");
      reset.type = "button";
      reset.dataset.calibrationReset = "true";
      reset.textContent = "Reset";
      reset.addEventListener("click", resetCalibrationPlacement);

      var copy = document.createElement("button");
      copy.type = "button";
      copy.dataset.calibrationCopy = "true";
      copy.textContent = "JSON kopieren";
      copy.addEventListener("click", copyCalibrationPlacements);

      actions.append(save, reset, copy);

      var status = document.createElement("p");
      status.className = "solea-configurator-calibrator__status";
      status.dataset.calibrationStatus = "true";
      status.textContent = "Noch keine Halskette ausgew\u00e4hlt.";

      panel.append(header, controls, actions, status);
      return panel;
    }

    function createPreviewZoom() {
      var overlay = document.createElement("div");
      overlay.className = "solea-configurator-preview-zoom solea-configurator-preview-zoom--necklace";
      overlay.hidden = true;
      overlay.setAttribute("aria-hidden", "true");
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.setAttribute("aria-label", "Vorschau vergr\u00f6\u00dfern");

      var dialog = document.createElement("div");
      dialog.className = "solea-configurator-preview-zoom__dialog";
      dialog.setAttribute("role", "document");

      var close = document.createElement("button");
      close.type = "button";
      close.className = "solea-configurator-preview-zoom__close";
      close.setAttribute("aria-label", "Vorschau schliessen");
      close.textContent = "X";
      close.addEventListener("click", closePreviewZoom);

      var modes = document.createElement("div");
      modes.className = "solea-configurator-preview-zoom__modes";

      function zoomModeButton(mode, label) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "solea-configurator-preview-zoom__mode";
        button.dataset.previewZoomMode = mode;
        button.textContent = label;
        button.addEventListener("click", function () {
          previewZoomMode = mode;
          populatePreviewZoom();
        });
        return button;
      }

      modes.append(
        zoomModeButton("detail", "Detailansicht"),
        zoomModeButton("full", "Gesamtansicht")
      );

      var content = document.createElement("div");
      content.className = "solea-configurator-preview-zoom__content";
      content.dataset.previewZoomContent = "true";

      dialog.append(close, modes, content);
      overlay.append(dialog);
      overlay.addEventListener("click", function (event) {
        if (event.target === overlay) closePreviewZoom();
      });

      document.addEventListener("keydown", function (event) {
        if (!overlay.hidden && event.key === "Escape") closePreviewZoom();
      });

      if (document.body) document.body.append(overlay);
      return overlay;
    }

    function createPreviewNode() {
      var panel = document.createElement("section");
      panel.className = "solea-configurator-preview-media";
      panel.dataset.soleaPreview = "true";
      panel.setAttribute("aria-label", "Live-Vorschau deiner Halsketten-Konfiguration");

      var stage = document.createElement("div");
      stage.className = "solea-configurator-preview-media__stage";
      stage.tabIndex = 0;
      stage.setAttribute("role", "button");
      stage.dataset.previewZoomTrigger = "true";
      stage.addEventListener("click", openPreviewZoom);
      stage.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        openPreviewZoom();
      });

      var chainImage = document.createElement("img");
      chainImage.className = "solea-configurator-preview-media__chain";
      chainImage.dataset.previewChain = "true";
      chainImage.alt = "";
      chainImage.loading = "eager";
      chainImage.fetchPriority = "high";

      var pendant = document.createElement("div");
      pendant.className = "solea-configurator-preview-media__pendant";
      pendant.dataset.previewPendant = "true";

      var epoxyImage = document.createElement("img");
      epoxyImage.dataset.previewEpoxy = "true";
      epoxyImage.alt = "";
      epoxyImage.loading = "eager";
      pendant.append(epoxyImage);

      var placeholder = document.createElement("div");
      placeholder.className = "solea-configurator-preview-media__placeholder";
      placeholder.textContent = "Wähle Material, Kette und Epoxiddesign";

      var zoomHint = document.createElement("span");
      zoomHint.className = "visually-hidden";
      zoomHint.textContent = "Vorschau vergr\u00f6\u00dfern";

      stage.append(chainImage, pendant, placeholder, zoomHint);

      var caption = document.createElement("div");
      caption.className = "solea-configurator-preview-media__caption";

      var title = document.createElement("strong");
      title.dataset.previewTitle = "true";
      title.textContent = "Vorschau";

      var details = document.createElement("span");
      details.dataset.previewDetails = "true";
      details.textContent = "Noch keine Auswahl";

      caption.append(title, details);
      if (calibrationMode) panel.append(stage, caption, createCalibrationPanel());
      else panel.append(stage, caption);
      return panel;
    }

    function isMobileLayout() {
      return window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
    }

    function ensureProductPreview(rootNode) {
      var productHost = document.querySelector(".product__photos") || document.querySelector("[data-product-images]");
      if (productHost) productHost.classList.add("solea-configurator-preview-host");

      var host = isMobileLayout() ? rootNode : productHost || rootNode;
      var existing = host.querySelector("[data-solea-preview]");
      if (existing) return existing;

      var node = createPreviewNode();
      if (host === rootNode && isMobileLayout()) {
        node.classList.add("solea-configurator-preview-media--mobile-sticky");
      }
      if (host === rootNode) {
        rootNode.insertBefore(node, rootNode.firstChild);
      } else {
        host.insertBefore(node, host.firstChild);
      }
      document.documentElement.classList.add("solea-configurator-preview-active");
      return node;
    }

    function previewDetailScale(placement) {
      var size = placement && Number.isFinite(Number(placement.size)) ? Number(placement.size) : DEFAULT_PREVIEW_PLACEMENT.size;
      return Math.max(3.7, Math.min(5.4, 40 / Math.max(size, 1)));
    }

    function updatePreviewZoomModeButtons() {
      if (!previewZoom) return;
      previewZoom.classList.toggle("is-detail", previewZoomMode === "detail");
      previewZoom.classList.toggle("is-full", previewZoomMode !== "detail");
      previewZoom.querySelectorAll("[data-preview-zoom-mode]").forEach(function (button) {
        var active = button.dataset.previewZoomMode === previewZoomMode;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    function applyDetailPreviewZoom(stageClone) {
      var chain = selectedPreviewChain();
      if (previewZoomMode !== "detail" || !chain) return;

      var shell = selectedShell(state);
      var placement = previewPlacement(chain, shell);
      var detailScale = previewDetailScale(placement);
      var layer = document.createElement("div");
      layer.className = "solea-configurator-preview-zoom__detail-layer";

      stageClone.classList.add("solea-configurator-preview-zoom__stage--detail");
      stageClone.style.setProperty("--detail-zoom-scale", detailScale);
      stageClone.style.setProperty("--detail-zoom-left", (50 - (placement.x * detailScale)) + "%");
      stageClone.style.setProperty("--detail-zoom-top", (50 - (placement.y * detailScale)) + "%");

      while (stageClone.firstChild) {
        layer.append(stageClone.firstChild);
      }
      stageClone.append(layer);
    }

    function populatePreviewZoom() {
      if (!previewZoom || !preview) return false;
      var content = previewZoom.querySelector("[data-preview-zoom-content]");
      if (!content) return false;
      var stage = preview.querySelector(".solea-configurator-preview-media__stage");
      if (!stage) return false;
      if (!selectedPreviewChain()) previewZoomMode = "full";
      updatePreviewZoomModeButtons();

      content.textContent = "";
      var stageClone = stage.cloneNode(true);
      stageClone.classList.add("solea-configurator-preview-zoom__stage");
      stageClone.removeAttribute("tabindex");
      stageClone.removeAttribute("role");
      stageClone.removeAttribute("aria-label");
      stageClone.removeAttribute("data-preview-zoom-trigger");
      applyDetailPreviewZoom(stageClone);
      content.append(stageClone);

      var caption = preview.querySelector(".solea-configurator-preview-media__caption");
      if (caption) {
        var captionClone = caption.cloneNode(true);
        captionClone.classList.add("solea-configurator-preview-zoom__caption");
        content.append(captionClone);
      }
      return true;
    }

    function openPreviewZoom() {
      previewZoomMode = selectedPreviewChain() ? "detail" : "full";
      if (!previewZoom || calibrationMode || !populatePreviewZoom()) return;
      previewZoomPreviousFocus = document.activeElement;
      previewZoom.hidden = false;
      previewZoom.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("solea-configurator-preview-zoom-open");
      if (document.body) document.body.classList.add("solea-configurator-preview-zoom-open");
      var close = previewZoom.querySelector(".solea-configurator-preview-zoom__close");
      if (close) close.focus({ preventScroll: true });
    }

    function closePreviewZoom() {
      if (!previewZoom || previewZoom.hidden) return;
      previewZoom.hidden = true;
      previewZoom.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("solea-configurator-preview-zoom-open");
      if (document.body) document.body.classList.remove("solea-configurator-preview-zoom-open");
      if (previewZoomPreviousFocus && typeof previewZoomPreviousFocus.focus === "function") {
        previewZoomPreviousFocus.focus({ preventScroll: true });
      }
    }

    function setPreviewImage(image, src, alt) {
      if (!image) return;
      if (src) {
        image.hidden = false;
        image.src = src;
        image.alt = alt || "";
      } else {
        image.hidden = true;
        image.removeAttribute("src");
        image.alt = "";
      }
    }

    function selectedShellRule(state) {
      return state.chainStyle ? firstMatchingRule(MATRIX.shellRules, state) : null;
    }

    function selectedShell(state) {
      var shellRule = selectedShellRule(state);
      return selectedOption((shellRule || { options: [] }).options, state.shellSize);
    }

    function selectedPreviewChain() {
      return selectedOption((activeBranch(state) || { options: [] }).options, state.chainStyle);
    }

    function roundedPlacement(placement) {
      var normalized = normalizePlacementValue(placement) || DEFAULT_PREVIEW_PLACEMENT;
      return {
        x: Number(normalized.x.toFixed(2)),
        y: Number(normalized.y.toFixed(2)),
        size: Number(normalized.size.toFixed(2)),
        scaleX: Number(normalized.scaleX.toFixed(3)),
        scaleY: Number(normalized.scaleY.toFixed(3)),
        rotate: Number(normalized.rotate.toFixed(2)),
      };
    }

    function previewPlacement(chain, shell) {
      var code = chain && chain.code ? chain.code : "";
      var saved = calibrationMode && code ? calibrationMap[code] : null;
      var draft = calibrationMode && code ? calibrationDrafts[code] : null;
      var placement = Object.assign({}, DEFAULT_PREVIEW_PLACEMENT, PREVIEW_PLACEMENTS[code] || {}, saved || {}, draft || {});
      return normalizePlacementValue(placement) || Object.assign({}, DEFAULT_PREVIEW_PLACEMENT);
    }

    function applyPreviewPlacement(pendant, chain, shell, epoxy) {
      if (!pendant) return;
      var placement = previewPlacement(chain, shell);
      var previewScale = epoxy && Number.isFinite(Number(epoxy.previewScale)) ? Number(epoxy.previewScale) : 1;
      pendant.style.setProperty("--preview-shell-x", placement.x + "%");
      pendant.style.setProperty("--preview-shell-y", placement.y + "%");
      pendant.style.setProperty("--preview-shell-size", (placement.size * previewScale) + "%");
      pendant.style.setProperty("--preview-shell-scale-x", placement.scaleX);
      pendant.style.setProperty("--preview-shell-scale-y", placement.scaleY);
      pendant.style.setProperty("--preview-shell-rotate", placement.rotate + "deg");
    }

    function renderCalibrationPanel(chain, placement, message) {
      if (!calibrationMode || !preview) return;
      var panel = preview.querySelector("[data-preview-calibrator]");
      if (!panel) return;
      if (!chain || !chain.code) {
        panel.hidden = true;
        preview.classList.remove("is-calibrating");
        return;
      }

      panel.hidden = false;
      preview.classList.add("is-calibrating");

      var normalized = normalizePlacementValue(placement) || previewPlacement(chain, selectedShell(state));
      var title = panel.querySelector("[data-calibration-title]");
      var statusLine = panel.querySelector("[data-calibration-status]");
      if (title) title.textContent = "Overlay-Kalibrierung: " + optionLabel(chain);
      panel.querySelectorAll("[data-calibration-input]").forEach(function (input) {
        var key = input.dataset.calibrationInput;
        var value = normalized[key];
        input.value = Number.isFinite(value) ? String(Number(value.toFixed(key === "scaleX" || key === "scaleY" ? 3 : 2))) : "";
      });
      if (statusLine) {
        statusLine.textContent = message || "Ziehen, Gr\u00f6\u00dfe anpassen, dann OK speichern. Die Schalengr\u00f6\u00dfe \u00e4ndert diese Bildgr\u00f6\u00dfe nicht.";
      }
    }

    function applyCalibrationPatch(patch, message) {
      var chain = selectedPreviewChain();
      if (!chain || !chain.code) return;
      var current = Object.assign({}, previewPlacement(chain, selectedShell(state)));
      Object.keys(patch).forEach(function (key) {
        current[key] = patch[key];
      });
      var placement = normalizePlacementValue(current);
      if (!placement) return;
      calibrationDrafts[chain.code] = placement;
      applyPreviewPlacement(preview.querySelector("[data-preview-pendant]"), chain, selectedShell(state), selectedOption(MATRIX.epoxyPatterns, state.epoxyPattern));
      renderCalibrationPanel(chain, placement, message || "Noch nicht gespeichert.");
    }

    function updateCalibrationDraft(key, value) {
      var patch = {};
      patch[key] = value;
      applyCalibrationPatch(patch, "Noch nicht gespeichert.");
    }

    function saveCalibrationPlacement() {
      var chain = selectedPreviewChain();
      if (!chain || !chain.code) return;
      var placement = roundedPlacement(calibrationDrafts[chain.code] || previewPlacement(chain, selectedShell(state)));
      calibrationMap[chain.code] = placement;
      calibrationDrafts[chain.code] = placement;
      writeCalibrationMap(calibrationMap);
      renderCalibrationPanel(chain, placement, "Gespeichert für " + chain.code + ". Danach JSON kopieren, damit wir es fest ins Theme übernehmen können.");
    }

    function resetCalibrationPlacement() {
      var chain = selectedPreviewChain();
      if (!chain || !chain.code) return;
      delete calibrationMap[chain.code];
      delete calibrationDrafts[chain.code];
      writeCalibrationMap(calibrationMap);
      renderPreview();
      renderCalibrationPanel(chain, previewPlacement(chain, selectedShell(state)), "Lokale Kalibrierung für " + chain.code + " entfernt.");
    }

    function copyCalibrationPlacements() {
      var chain = selectedPreviewChain();
      var exportMap = Object.assign({}, calibrationMap);
      if (chain && chain.code && calibrationDrafts[chain.code]) {
        exportMap[chain.code] = roundedPlacement(calibrationDrafts[chain.code]);
      }
      var ordered = {};
      Object.keys(exportMap).sort().forEach(function (code) {
        ordered[code] = roundedPlacement(exportMap[code]);
      });
      var json = JSON.stringify(ordered, null, 2);
      copyText(json).then(function () {
        renderCalibrationPanel(chain, chain ? previewPlacement(chain, selectedShell(state)) : null, "JSON wurde in die Zwischenablage kopiert.");
      }).catch(function () {
        renderCalibrationPanel(chain, chain ? previewPlacement(chain, selectedShell(state)) : null, "Kopieren fehlgeschlagen. Bitte Browser-Berechtigung pruefen.");
      });
    }

    function bindCalibrationDrag() {
      if (!calibrationMode || !preview) return;
      var stage = preview.querySelector(".solea-configurator-preview-media__stage");
      if (!stage) return;
      stage.addEventListener("pointerdown", function (event) {
        var chain = selectedPreviewChain();
        if (!chain || !chain.code) return;
        event.preventDefault();
        if (stage.setPointerCapture) stage.setPointerCapture(event.pointerId);

        function move(clientX, clientY) {
          var rect = stage.getBoundingClientRect();
          applyCalibrationPatch({
            x: ((clientX - rect.left) / rect.width) * 100,
            y: ((clientY - rect.top) / rect.height) * 100,
          }, "Position gezogen. OK speichern, wenn sie passt.");
        }

        function onMove(moveEvent) {
          if (moveEvent.pointerId !== event.pointerId) return;
          move(moveEvent.clientX, moveEvent.clientY);
        }

        function onUp(upEvent) {
          if (upEvent.pointerId !== event.pointerId) return;
          stage.removeEventListener("pointermove", onMove);
          stage.removeEventListener("pointerup", onUp);
          stage.removeEventListener("pointercancel", onUp);
        }

        move(event.clientX, event.clientY);
        stage.addEventListener("pointermove", onMove);
        stage.addEventListener("pointerup", onUp);
        stage.addEventListener("pointercancel", onUp);
      });
    }

    function renderPreview() {
      if (!preview) return;

      var material = selectedOption(MATRIX.materials, state.material);
      var braceletType = selectedOption(MATRIX.braceletTypes, state.braceletType);
      var chain = selectedPreviewChain();
      var shell = selectedShell(state);
      var epoxy = selectedOption(MATRIX.epoxyPatterns, state.epoxyPattern);
      var base = chain || braceletType || material;

      var chainImage = preview.querySelector("[data-preview-chain]");
      var epoxyImage = preview.querySelector("[data-preview-epoxy]");
      var pendant = preview.querySelector("[data-preview-pendant]");
      var title = preview.querySelector("[data-preview-title]");
      var details = preview.querySelector("[data-preview-details]");

      setPreviewImage(chainImage, optionImageUrl(root, base, "image"), base ? optionLabel(base) : "");
      setPreviewImage(epoxyImage, optionImageUrl(root, epoxy, "image"), epoxy ? optionLabel(epoxy) : "");

      preview.classList.toggle("has-base", Boolean(base));
      preview.classList.toggle("has-chain", Boolean(chain));
      preview.classList.toggle("has-epoxy", Boolean(epoxy));
      applyPreviewPlacement(pendant, chain, shell, epoxy);
      if (pendant) pendant.hidden = !chain;
      renderCalibrationPanel(chain, chain ? previewPlacement(chain, shell) : null);

      if (title) title.textContent = chain ? optionLabel(chain) : base ? optionLabel(base) : "Vorschau";
      if (details) {
        var parts = [
          material ? optionLabel(material) : "",
          braceletType ? optionLabel(braceletType) : "",
          shell ? optionLabel(shell) : "",
        ].filter(Boolean);
        details.textContent = parts.length ? parts.join(" - ") : "Noch keine Auswahl";
      }
      if (previewZoom && !previewZoom.hidden) populatePreviewZoom();
    }

    function optionLabel(option) {
      return option.display;
    }

    function variantLabel(field, option) {
      if (!field || field.id !== "chainStyle" || !option) return "";
      var index = field.options.findIndex(function (item) {
        return item.value === option.value;
      });
      if (index < 0) return optionLabel(option);
      return "Variante " + (index + 1);
    }

    function customerChoiceLabel(field, option) {
      if (!option) return "";
      return field && field.id === "chainStyle" ? variantLabel(field, option) : optionLabel(option);
    }

    function customerSelectionLabel(field, option) {
      if (!option) return "";
      if (field.id === "epoxyPattern") {
        return ((soleaI18n.exact || {})["Ausgewählt"] || "Ausgewählt");
      }
      return customerChoiceLabel(field, option);
    }

    function epoxyGroupName(option) {
      var label = String((option && (option.display || option.value)) || "").trim();
      var match = label.match(/^([A-Za-z]+)/);
      return match ? match[1].toUpperCase() : "OTHER";
    }

    var EPOXY_GROUP_LABELS = {
      BLUE: "Blau",
      LIGHT: "Hell",
      GOLD: "Gold",
      COPPER: "Kupfer",
      YELLOW: "Gelb",
      RED: "Rot",
      GREEN: "Gr\u00fcn",
      VIOLET: "Violett",
      PINK: "Rosa",
      DARK: "Dunkel",
      COLORSHIFT: "Farbwechsel",
      UNICOLOR: "Einfarbig",
      OTHER: "Sonstige",
    };

    var EPOXY_GROUP_ORDER = [
      "BLUE",
      "LIGHT",
      "GOLD",
      "COPPER",
      "YELLOW",
      "RED",
      "GREEN",
      "VIOLET",
      "PINK",
      "DARK",
      "COLORSHIFT",
      "UNICOLOR",
      "OTHER",
    ];

    function epoxyGroupLabel(groupName) {
      return EPOXY_GROUP_LABELS[groupName] || groupName;
    }

    function epoxyGroupRank(groupName) {
      var index = EPOXY_GROUP_ORDER.indexOf(groupName);
      return index === -1 ? EPOXY_GROUP_ORDER.length : index;
    }

    function epoxyGroups() {
      var groups = [];
      var seen = Object.create(null);
      MATRIX.epoxyPatterns.forEach(function (option) {
        var group = epoxyGroupName(option);
        if (!seen[group]) {
          seen[group] = { name: group, count: 0 };
          groups.push(seen[group]);
        }
        seen[group].count += 1;
      });
      return groups.sort(function (a, b) {
        var rank = epoxyGroupRank(a.name) - epoxyGroupRank(b.name);
        return rank || epoxyGroupLabel(a.name).localeCompare(epoxyGroupLabel(b.name), "de");
      });
    }

    function baseOptionsForField(field) {
      if (field.id !== "epoxyPattern" || !epoxyPatternGroup) return field.options;
      return field.options.filter(function (option) {
        return epoxyGroupName(option) === epoxyPatternGroup;
      });
    }

    function clearEpoxySelectionOutsideGroup() {
      if (!epoxyPatternGroup || !state.epoxyPattern) return;
      var selected = selectedOption(MATRIX.epoxyPatterns, state.epoxyPattern);
      if (!selected || epoxyGroupName(selected) !== epoxyPatternGroup) {
        delete state.epoxyPattern;
      }
    }

    function activeFieldFor(fields) {
      if (activeFieldId && fields.some(function (field) { return field.id === activeFieldId; })) {
        return activeFieldId;
      }
      var firstMissing = fields.find(function (field) {
        return field.required && !state[field.id];
      });
      if (firstMissing) return firstMissing.id;
      return fields.length ? fields[fields.length - 1].id : "";
    }

    function filteredOptions(field) {
      var query = String(searchQueries[field.id] || "").trim().toLowerCase();
      var baseOptions = baseOptionsForField(field);
      if (!query) {
        if (!field.searchable) return baseOptions;
        var limit = optionLimits[field.id] || SEARCHABLE_INITIAL_LIMIT;
        return baseOptions.slice(0, Math.min(baseOptions.length, limit));
      }
      return baseOptions.filter(function (option) {
        return [option.display, option.value, option.code].join(" ").toLowerCase().indexOf(query) !== -1;
      });
    }

    function renderChoice(field, option) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "solea-configurator__choice";
      button.setAttribute("aria-pressed", String(state[field.id] === option.value));
      var visibleLabel = customerChoiceLabel(field, option);
      var epoxyChoiceLabel = ((soleaI18n.exact || {})["Epoxiddesign ausw\u00e4hlen"] || "Epoxiddesign ausw\u00e4hlen") + ": " + visibleLabel;
      if (field.id === "epoxyPattern") button.setAttribute("aria-label", epoxyChoiceLabel);
      if (field.id === "chainStyle") button.title = optionLabel(option);
      if (state[field.id] === option.value) button.classList.add("is-selected");

      var swatch = document.createElement("span");
      swatch.className = "solea-configurator__swatch";
      var image = optionImageUrl(root, option, "thumbnail");
      if (image) {
        swatch.classList.add("is-image");
        swatch.style.setProperty("--choice-image", "url('" + image + "')");
      } else {
        swatch.style.setProperty("--choice-color", "#e7ecef");
      }

      button.append(swatch);
      if (field.id !== "epoxyPattern") {
        var label = document.createElement("span");
        label.className = "solea-configurator__choice-label";
        label.textContent = visibleLabel;
        button.append(label);
      }

      if (option.priceDeltaCents) {
        var price = document.createElement("span");
        price.className = "solea-configurator__choice-note";
        price.textContent = "+ " + formatMoney(option.priceDeltaCents);
        button.append(price);
      }

      button.addEventListener("click", function () {
        state[field.id] = option.value;
        var fields = currentFields(state);
        activeFieldId = "";
        var fieldIds = fields.map(function (item) { return item.id; });
        var index = fieldIds.indexOf(field.id);
        fieldIds.slice(index + 1).forEach(function (nextId) {
          delete state[nextId];
          delete searchQueries[nextId];
          delete optionLimits[nextId];
        });
        render();
      });

      return button;
    }

    function renderEpoxyGroupFilter() {
      var wrap = document.createElement("div");
      wrap.className = "solea-configurator__pattern-groups";
      wrap.setAttribute("aria-label", "Farbgruppe filtern");
      wrap.addEventListener("scroll", function () {
        epoxyGroupScrollLeft = wrap.scrollLeft || 0;
      }, { passive: true });
      if (epoxyGroupScrollLeft > 0) {
        window.requestAnimationFrame(function () {
          wrap.scrollLeft = epoxyGroupScrollLeft;
        });
      }

      var all = document.createElement("button");
      all.type = "button";
      all.textContent = "Alle (" + MATRIX.epoxyPatterns.length + ")";
      all.setAttribute("aria-pressed", String(!epoxyPatternGroup));
      if (!epoxyPatternGroup) all.classList.add("is-selected");
      all.addEventListener("click", function () {
        epoxyGroupScrollLeft = wrap.scrollLeft || epoxyGroupScrollLeft;
        epoxyPatternGroup = "";
        delete optionLimits.epoxyPattern;
        render();
      });
      wrap.append(all);

      epoxyGroups().forEach(function (group) {
        var button = document.createElement("button");
        button.type = "button";
        button.textContent = epoxyGroupLabel(group.name) + " (" + group.count + ")";
        button.setAttribute("aria-pressed", String(epoxyPatternGroup === group.name));
        if (epoxyPatternGroup === group.name) button.classList.add("is-selected");
        button.addEventListener("click", function () {
          epoxyGroupScrollLeft = wrap.scrollLeft || epoxyGroupScrollLeft;
          epoxyPatternGroup = group.name;
          clearEpoxySelectionOutsideGroup();
          delete optionLimits.epoxyPattern;
          render();
        });
        wrap.append(button);
      });

      return wrap;
    }

    function restoreEpoxyGroupScroll() {
      if (!epoxyGroupScrollLeft) return;
      var wrap = fieldsRoot.querySelector(".solea-configurator__pattern-groups");
      if (!wrap) return;
      var target = Math.min(epoxyGroupScrollLeft, Math.max(0, wrap.scrollWidth - wrap.clientWidth));
      function apply() {
        wrap.scrollLeft = target;
      }
      apply();
      window.requestAnimationFrame(apply);
      window.setTimeout(apply, 0);
    }

    function renderOptionPaging(field, shownCount) {
      var wrap = document.createElement("div");
      wrap.className = "solea-configurator__field-actions";

      var more = document.createElement("button");
      more.type = "button";
      more.textContent = "Weitere Designs anzeigen";
      more.addEventListener("click", function () {
        optionLimits[field.id] = Math.min(field.options.length, shownCount + SEARCHABLE_PAGE_SIZE);
        render();
      });

      var all = document.createElement("button");
      all.type = "button";
      all.textContent = "Alle Designs anzeigen";
      all.addEventListener("click", function () {
        optionLimits[field.id] = field.options.length;
        render();
      });

      wrap.append(more, all);
      return wrap;
    }

    function renderField(field, activeId) {
      var isOpen = field.id === activeId;
      var section = document.createElement("section");
      section.className = "solea-configurator__field";
      section.classList.add(isOpen ? "is-open" : "is-collapsed");
      section.dataset.field = field.id;

      var header = document.createElement("button");
      header.type = "button";
      header.className = "solea-configurator__field-header";
      header.setAttribute("aria-expanded", String(isOpen));
      header.addEventListener("click", function () {
        activeFieldId = field.id;
        render();
      });

      var label = document.createElement("span");
      label.className = "solea-configurator__field-label";
      label.textContent = field.label;

      var selected = document.createElement("span");
      selected.className = "solea-configurator__field-state";
      var selectedChoice = selectedOption(field.options, state[field.id]);
      selected.textContent = selectedChoice ? customerSelectionLabel(field, selectedChoice) : "Noch offen";

      header.append(label, selected);
      section.append(header);

      var body = document.createElement("div");
      body.className = "solea-configurator__field-body";
      body.hidden = !isOpen;
      if (!isOpen) {
        section.append(body);
        return section;
      }

      if (field.id === "epoxyPattern") body.append(renderEpoxyGroupFilter());

      var options = filteredOptions(field);
      var baseOptions = baseOptionsForField(field);
      var grid = document.createElement("div");
      grid.className = "solea-configurator__choice-grid";
      if (field.id === "epoxyPattern") grid.classList.add("is-patterns");
      if (field.id === "length") grid.classList.add("is-lengths");
      options.forEach(function (option) {
        grid.append(renderChoice(field, option));
      });
      body.append(grid);

      if (field.searchable && !searchQueries[field.id] && baseOptions.length > options.length) {
        var hint = document.createElement("p");
        hint.className = "solea-configurator__field-hint";
        hint.textContent = "Zeige " + options.length + " von " + baseOptions.length + " Designs. Du kannst weitere Designs laden.";
        body.append(hint);
        body.append(renderOptionPaging(field, options.length));
      } else if (field.searchable) {
        var count = document.createElement("p");
        count.className = "solea-configurator__field-hint";
        var groupText = field.id === "epoxyPattern" && epoxyPatternGroup ? " in " + epoxyGroupLabel(epoxyPatternGroup) : "";
        count.textContent = options.length + " Designs" + groupText + " verfügbar.";
        body.append(count);
      }

      section.append(body);
      return section;
    }

    function updateProgress() {
      var requiredFields = currentFields(state).filter(function (field) { return field.required; });
      var done = requiredFields.filter(function (field) { return state[field.id]; }).length;
      var percent = requiredFields.length ? Math.round((done / requiredFields.length) * 100) : 0;
      progressBar.style.width = percent + "%";
    }

    function renderStatus() {
      var missing = missingFields(state);
      if (missing.length === 0) {
        setStatus("Auswahl bereit für den Warenkorb.", "ready");
      } else if (missing.length === 1) {
        setStatus("Noch 1 Schritt offen: " + missing[0] + ".");
      } else {
        setStatus("Noch " + missing.length + " Schritte offen.");
      }
    }

    function renderPrice() {
      var prices = priceParts(state);
      if (priceTotal) priceTotal.textContent = formatMoney(prices.total);
      if (priceNote) {
        priceNote.textContent = prices.extras ? "inkl. " + formatMoney(prices.extras) + " Optionsaufschlag" : "ohne Optionsaufschlag";
      }
      updateProductPrice(prices.total);
    }

    function render() {
      normalizeState(state);
      fieldsRoot.replaceChildren();
      var fields = currentFields(state);
      activeFieldId = activeFieldFor(fields);
      fields.forEach(function (field) {
        fieldsRoot.append(renderField(field, activeFieldId));
      });
      restoreEpoxyGroupScroll();
      updateProgress();
      renderStatus();
      renderPrice();
      renderPreview();
      updateCartInputs(cartForm, state);
    }

    cartForm.addEventListener("submit", function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var missing = missingFields(state);
      if (missing.length > 0) {
        var firstMissing = currentFields(state).find(function (field) {
          return field.required && !state[field.id];
        });
        if (firstMissing) {
          activeFieldId = firstMissing.id;
          render();
        }
        setStatus("Bitte zuerst auswählen: " + missing.join(", ") + ".", "error");
        root.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      if (!diyScopeConfirmed(root)) {
        setStatus(diyScopeTexts().error, "error");
        var confirmation = root.querySelector("[data-diy-scope-confirmation]");
        var confirmationInput = root.querySelector("[data-diy-scope-confirm-input]");
        if (confirmation && confirmation.scrollIntoView) {
          confirmation.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          root.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        if (confirmationInput && confirmationInput.focus) confirmationInput.focus();
        return;
      }

      updateCartInputs(cartForm, state);
      var items;
      try {
        items = buildCartItems(state, cartForm);
      } catch (error) {
        setStatus(error.message, "error");
        return;
      }

      disableSubmit(cartForm, true);
      setStatus("Lege Auswahl in den Warenkorb ...", "ready");
      addConfiguredItems(items)
        .then(function () {
          window.location.href = (window.theme && window.theme.routes && window.theme.routes.cartPage) || "/cart";
        })
        .catch(function (error) {
          var hasAddOn = priceParts(state).extras > 0;
          var message = hasAddOn
            ? "Der Aufpreis konnte nicht in den Warenkorb gelegt werden: " + error.message + ". Die Auswahl wurde nicht zum Basispreis hinzugefügt."
            : "Die Auswahl konnte nicht in den Warenkorb gelegt werden: " + error.message;
          setStatus(message, "error");
          disableSubmit(cartForm, false);
        });
    }, true);

    resetButton.addEventListener("click", function () {
      Object.keys(state).forEach(function (key) { delete state[key]; });
      Object.keys(searchQueries).forEach(function (key) { delete searchQueries[key]; });
      Object.keys(optionLimits).forEach(function (key) { delete optionLimits[key]; });
      epoxyPatternGroup = "";
      epoxyGroupScrollLeft = 0;
      activeFieldId = "";
      restoreProductPrice();
      render();
    });

    bindCalibrationDrag();
    syncPreviewHost();
    window.addEventListener("resize", schedulePreviewHostSync, { passive: true });
    render();
    applySoleaI18n(root, soleaI18n);
  }

  if (!isActive()) return;

  document.querySelectorAll("[data-solea-configurator-root]").forEach(initRoot);
})();
